/* ── Redirect old car filter URLs to new bilfilter page ── */
(function() {
  if (!window.location.pathname.startsWith('/collections/')) return;
  var params = new URLSearchParams(window.location.search);
  var filtersRaw = params.get('filters');
  if (!filtersRaw) return;
  try {
    var filters = JSON.parse(filtersRaw);
    if (!Array.isArray(filters)) return;
    var brand = '', model = '', year = '';
    filters.forEach(function(f) {
      if (typeof f !== 'string') return;
      if (f.startsWith('brands:')) brand = f.replace('brands:', '');
      if (f.startsWith('models:')) model = f.replace('models:', '');
      if (f.startsWith('years:')) year = f.replace('years:', '');
      if (f.startsWith('brand_model_year:')) {
        var parts = f.replace('brand_model_year:', '').split('/');
        if (parts.length === 3) { brand = parts[0]; model = parts[1]; year = parts[2]; }
      }
    });
    if (brand && model && year) {
      window.location.replace('/pages/filter?pf_brand=' + encodeURIComponent(brand) + '&pf_model=' + encodeURIComponent(model) + '&pf_year=' + encodeURIComponent(year));
    }
  } catch(e) {}
})();

var collectionPage = document.querySelector(".template-collection") ? document.querySelector(".template-collection") : document.querySelector(".template-search");
var SearchPage = document.querySelector(".template-search") ? document.querySelector(".template-search") : document.querySelector(".template-search");
var filtersWrapper = document.querySelector(".page-layout-sidebar-inner-content.old-side-bar-content");
var newFiltersWrapper = document.querySelector(".custom-page-layout-sidebar-inner-content.page-layout-sidebar-inner-content");
let sideBar = collectionPage?.querySelector(".filters_side_bar_custom ") || SearchPage?.querySelector("default-layout-sidebar");
let defaultProductCount = 0
const sortBy = collectionPage ? collectionPage.querySelector("#collection-sort-order") : null;
var productCount = document.querySelector("#ProductCount");
var productGrid = document.querySelector("#product-grid");
var defaultProducts = productGrid ? productGrid.innerHTML : null;
// var collectionId = document.querySelector("#ProductGridContainer").getAttribute("col-id") === null ? "" : document.querySelector("#ProductGridContainer").getAttribute("col-id");
collectionId = document.querySelector("#ProductGridContainer")?.getAttribute("col-id") || ""
function getCollectionDefaultSort() {
  const el = document.querySelector('#ProductGridContainer');
  return (el && el.dataset && el.dataset.defaultSort) ? el.dataset.defaultSort : null;
}

let searchInput = collectionPage ? collectionPage.querySelector("#search-input") : null
// let searchInputGlobal = collectionPage ? collectionPage.querySelector("#header-global-search-input") : null
let searchPageHeading = collectionPage ? collectionPage.querySelector(".search-result-heading") : null
let searchBtn = collectionPage ? collectionPage.querySelector("#search-Btn") : null
// var defautPagination = collectionPage.querySelector(".pagination");
var collectionLoader = collectionPage ? collectionPage.querySelector(".new-collection-load") : null;
// var normalFilters = collectionPage ? collectionPage.querySelectorAll(".normal_filter") : null;
var filterLoader = collectionPage ? collectionPage.querySelector(".filters_loader") : null;
var fullWidths = collectionPage ? collectionPage.querySelectorAll(".page-layout-fullwidth") : null;
var mainContent = collectionPage ? collectionPage.querySelector("#MainContent") : null;
var mblFilter = collectionPage ? collectionPage.querySelector(".page-layout-sidebar-inner-content") : SearchPage.querySelector("page-layout-sidebar-inner-content");
var windowUrl = window.location.href;
let sidebarOpenButton = collectionPage ? collectionPage.querySelector(".button-sidebar-drawer-open") : null
let collectionPageHeading = collectionPage ? collectionPage.querySelector(".page-hero-heading") : null
let collectionPageHeadingWrap = collectionPage ? collectionPage.querySelector(".page-hero-content-wrapper") : null
let totalFoundProducts = 0
// === Utvalgte (manual) støtte ===
let defaultOrderHandles = [];

function readManualOrderFromJSON() {
  const el = document.getElementById('sbr-manual-order');
  if (!el) return [];
  try {
    const arr = JSON.parse(el.textContent.trim());
    if (Array.isArray(arr)) return arr.filter(Boolean);
  } catch (e) {}
  return [];
}

// Fallback: trekk ut fra server-renderte kort (hvis de finnes)
function extractHandlesFromGrid(rootEl) {
  if (!rootEl) return [];
  const links = Array.from(rootEl.querySelectorAll('a[href*="/products/"]'));
  const handles = links
    .map(a => {
      const href = a.getAttribute('href') || '';
      const parts = href.split('/products/');
      if (parts.length < 2) return null;
      return parts[1].split('?')[0].replace(/\/+$/, '');
    })
    .filter(Boolean);
  const seen = new Set();
  return handles.filter(h => (seen.has(h) ? false : (seen.add(h), true)));
}

function collectDefaultOrderHandles() {
  if (defaultOrderHandles.length) return;

  // 1) Prøv JSON-blokka (sikker kilde)
  const fromJson = readManualOrderFromJSON();
  if (fromJson.length) {
    defaultOrderHandles = fromJson;
    return;
  }
  // 2) Fallback: forsøk hente fra allerede renderte kort
  defaultOrderHandles = extractHandlesFromGrid(productGrid);
}

function buildManualOrderMap() {
  const map = new Map();
  defaultOrderHandles.forEach((h, i) => map.set(h, i));
  return map;
}

function sortHitsByManual(hits) {
  if (!Array.isArray(hits) || !hits.length || !defaultOrderHandles.length) return hits;
  const orderMap = buildManualOrderMap();
  const BIG = Number.MAX_SAFE_INTEGER;
  return hits.slice().sort((a, b) => {
    const ia = orderMap.has(a.handle) ? orderMap.get(a.handle) : BIG;
    const ib = orderMap.has(b.handle) ? orderMap.get(b.handle) : BIG;
    return ia - ib;
  });
}

function ensureManualSortOption() {
  if (!sortBy) return;
  const hasManual = Array.from(sortBy.options).some(o => o.value === 'manual');
  if (!hasManual) {
    const opt = document.createElement('option');
    opt.value = 'manual';
    opt.textContent = 'Utvalgte';
    sortBy.insertBefore(opt, sortBy.firstChild);
  }
}


// var for api request time
// let timeoutId;
// Initialize abort controller variable
abortController = window.abortController;

let isRequestInProgress = false;
var minVal = 0;
var maxVal = 0;
var sortVal = 0;
var pageVal = 0;
var checkVal = 0;
const url = window.location.href;
// code added by gulraiz 
//   keys for Algoliya
appId = "SPSQXF4IYY"
indexName = "shopify_products"
viewKey = "592fba5adc5b8a34e6efd7ac36235a11"
client = algoliasearch(appId, viewKey);
index = client.initIndex(indexName);
// different indexes for sorting
const titleAsc = client.initIndex('title_asc');
const titleDesc = client.initIndex('title_desc');
const createdAsc = client.initIndex('created_asc');
const createdDesc = client.initIndex('created_desc');
const priceAsc = client.initIndex('price_asc');
const priceDesc = client.initIndex('price_desc');
const bestSeller = client.initIndex('best_seller');
/* ── Custom sorts ── */
var customSortsData = [];
try {
  var rawCS = window.storeCustomSorts;
  if (rawCS && rawCS.sorts) customSortsData = rawCS.sorts;
} catch(e) {}

function applyCustomTagSort(hits, sortTags) {
  var priorityMap = {};
  sortTags.forEach(function(t) { priorityMap[t.tag.toLowerCase()] = t.priority; });
  var maxPriority = sortTags.length + 1;
  return hits.slice().sort(function(a, b) {
    var aTags = Array.isArray(a._tags) ? a._tags : (Array.isArray(a.tags) ? a.tags : []);
    var bTags = Array.isArray(b._tags) ? b._tags : (Array.isArray(b.tags) ? b.tags : []);
    var aPri = maxPriority, bPri = maxPriority;
    aTags.forEach(function(tag) { var p = priorityMap[tag.toLowerCase()]; if (p !== undefined && p < aPri) aPri = p; });
    bTags.forEach(function(tag) { var p = priorityMap[tag.toLowerCase()]; if (p !== undefined && p < bPri) bPri = p; });
    return aPri - bPri;
  });
}
//   facets names that we have
// const facetsNames = ["models","vendor","brand_model_year","brands","tags","collection_ids"]
facetsNames = ["vendor", "tags"]
// algoliya api path 
const filterValApi = `https://${appId}.algolia.net/1/indexes/${indexName}/query`;
// request data 
requestData =  {
    query: '',
    facets: facetsNames,
    facetFilters: [`collection_ids:${collectionId}`],
    maxValuesPerFacet: 1000,
    hitsPerPage: 40,
    page: 0
};
// === CAR FILTER VIA BACKEND API (100% nøyaktig) ===
async function fetchCarFilterIds(brand, model, year) {
  try {
    const response = await fetch('https://phpstack-1204751-4260962.cloudwaysapps.com/api/car/filter-products', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ brand, model, year })
    });
    const data = await response.json();
    if (data.status && data.shopify_ids && data.shopify_ids.length > 0) {
      return data.shopify_ids;
    }
    return [];
  } catch (error) {
    console.error('Car filter API error:', error);
    return [];
  }
}

function buildIdFilter(shopifyIds) {
  if (!shopifyIds || shopifyIds.length === 0) return '';
  return '(' + shopifyIds.map(id => `id = ${id}`).join(' OR ') + ')';
}

function extractCarFiltersFromUrl() {
  const filters = getUrlFilters();
  const flat = flattenUrlFilters(filters);
  const brand = flat.find(str => str.startsWith('brands:'));
  const model = flat.find(str => str.startsWith('models:'));
  const year = flat.find(str => str.startsWith('years:'));
  if (brand && model && year) {
    return {
      brand: brand.split(':')[1],
      model: model.split(':')[1],
      year: year.split(':')[1]
    };
  }
  // Also support old format
  const bmy = flat.find(str => str.startsWith('brand_model_year:'));
  if (bmy) {
    const parts = bmy.split(':')[1].split('/');
    if (parts.length === 3) {
      return { brand: parts[0], model: parts[1], year: parts[2] };
    }
  }
  return null;
}
// === END CAR FILTER ===
document.addEventListener("click",(e)=>{
    if(e.target.classList.contains("head-slot-global-search-link")){
        requestData.query = ""
    }
})
// finding  common function
function matchArray(array1, array2) {
    // Use the filter method to find common elements
    return array1.filter(obj1 => array2.some(obj2 => obj1.name === obj2.tag));
}
// funtion to convert object to array
function objectToArray(obj) {
    if (typeof obj !== "object" || obj === null) {
        return obj;
    }
    if (Array.isArray(obj)) {
        return obj.map(item => objectToArray(item));
    }
    return Object.entries(obj).map(([name, value]) => ({
        name,
        value: objectToArray(value),
    }));
}
// fnction abort controll
// Debounce function implementation
function debounce(func, delay) {
    let timeoutId;
    return (...args) => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => func.apply(this, args), delay);
    };
  }
//   func ends
const deboundHandleSort = debounce(handleSortChange,400)
// const deboundpredictiveSearch = debounce(createPredictiveSearch,400)
const deboundAiSearch = debounce(optimizeSearchQuery,400)
const debouncedHandlePriceRange = debounce(handlePriceRange,500)
// fnction abort controll ends
// function endss
// // function predictive search request
// function createPredictiveSearch(query){
//     if (abortController) {
//         abortController.abort();
//     }
//         // Create new controller for current request
//     abortController = new AbortController();
//     // setting newreqdata and removing unnecessary fields
//     // let newReqData = {...requestData}
//     let newReqData = JSON.parse(JSON.stringify(requestData));
//     newReqData.facetFilters = ""
//     newReqData.maxValuesPerFacet = 1
//     newReqData.hitsPerPage = 5
//     // if query empty? set hits to 0
//     if(query == ""){
//         newReqData.hitsPerPage = 0
//     }
//      // if request us in progress ? then return
//     //  if (isRequestInProgress) return
//      // if not then set it true
//     //  isRequestInProgress = true;
//     index.search(query, newReqData).then(({hits}) => {
//         createPredictiveUI(hits)
//     }).catch(error => {
//         if (error.name !== 'AbortError') {
//             console.error("Error performing search:", error);
//             console.error('Fetch error:', error);
//         }
//     }).finally(() => {
//         // setting the is request in progress false
//         // isRequestInProgress = false
//     });

// }
// // function predictive search  ends
// // function predictive search UI 
// function createPredictiveUI(products){
//     console.log("create predictive caled")
//     let spinner = document.querySelector("header").querySelector('.spinner-sm')
//     console.log("before removing class")
//     spinner.classList.remove("spinner")
//     console.log("after removing class")
//     let predictiveContainer = document.querySelector("header")?.querySelector(".predictive-search-loading-state")
//     let itemsPredicted = ""
//     let wrapper = ""
//     if(products.length > 0){
//         products.forEach((product,i)=>{
//             itemsPredicted +=
//             `
//             <li id="predictive-search-option-product-${i}" class="predictive-search-list-item predictive-search-list-item-product" role="option" aria-selected="false">
//                 <a href="/products/${product.handle}" class="predictive-search-item predictive-search-item-link" tabindex="-1">
//                     <div class="predictive-search-item-image-wrap color-background-2">
//                         <div class="aspect-ratio" style="--ratio-percent: 75.0%;">
//                             <img src="${product.image}" alt="${product.title}" width="108" height="81" loading="lazy" class="predictive-search-item-image" >
//                         </div>
//                     </div>
//                     <div class="predictive-search-item-content">
//                     <span class="visually-hidden">
//                         Leverandør
//                     </span>
//                         <div class="predictive-search-item-vendor">${product.title}</div>
//                         <h3 class="predictive-search-item-heading typography-body">${product.handle}</h3>
//                         <div class="price">
//                             <div class="price-container">
//                                 <div class="price-regular ">
//                                     <span class="visually-hidden">Vanlig pris</span>
//                                     <span class="price-item price-item-regular" data-wpd-product-handle="rattadapter-mercedes-a-b-c-sprinter" data-wpd-variant-id="45940844888288" data-wpd-variant-price="113000" data-wpd-variant-compare-at-price="0" data-wpd-product-collection-ids="418629222624,449070792928,418629452000,449070825696,418628993248,418615656672,434087231712,434126160096,449070760160,449070858464,418627256544,449070891232,418629124320,449070924000,449070956768,449070989536,418618278112,449071022304,449071055072,418617524448,418618179808,418618147040,418618114272,449071087840,449071120608,449071153376,449071186144,446863835360,418627715296,418627584224,449071218912,449071251680,418617884896,418770256096,418629255392" data-wpd-product-id="8317854613728">
//                                         ${product.variants.price ? product.variants.price : product.variants[0].node.price }
//                                         <span class="sup">inkl. mva</span>
//                                     </span>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 </a>
//             </li>
//             `
//         })
//         // now assign the wrapper with the content of products
//         wrapper =
//         `
//         <div class="predictive-search-results-group-wrapper ">
//         <div class="predictive-search-results-group"></div>
//         <div class="predictive-search-results-group"><div class="predictive-search-results-group-section">
//             <h3 id="predictive-search-products" class="predictive-search-heading predictive-search-heading-products h5">
//                 Produkter
//             </h3>
//             <ul id="predictive-search-results-item-product-list" class="predictive-search-results-item-list"><li id="predictive-search-option-product-1" class="predictive-search-list-item predictive-search-list-item-product" role="option" aria-selected="false">
//                 ${
//                     itemsPredicted
//                 }
//             </ul>
//         </div></div>
//         </div>
//         `
//         if(predictiveContainer.childElementCount > 1){
//             let suggestionsDiv = predictiveContainer.lastElementChild
//             suggestionsDiv.remove()
//             predictiveContainer.innerHTML += wrapper
//         }
//         else{
//             predictiveContainer.innerHTML += wrapper
//         }
//     }
//     else{
//         if(predictiveContainer.childElementCount > 1){
//             let suggestionsDiv = predictiveContainer.lastElementChild
//             suggestionsDiv.remove()
//         }
//     }
   
// }
// function to optimize seach query 
// function to optimize seach query 
function optimizeSearchQuery(query){
    console.log("called  ai search")
    replaceInnerHTMLWithProducts("#product-grid")
    replaceInnerHTMLWithFilters("#custom-strowmmen-filters")
    return fetch(`https://phpstack-1204751-4260962.cloudwaysapps.com/api/ai/search/logic?query=${query}`).then(res=>{
        return res.json()
    }).then(data=>{
        removeEmptyFields(data.parameters)
    })
    
}
// function to optimize seach query ends
// function to check if has brand model year 
function hasBrandModelYear(url = window.location.href) {
    let params = new URL(url).searchParams; 
    
    if (params.has("filters")) { 
        let filtersValue = params.get("filters");
        return filtersValue.includes("brand_model_year") || filtersValue.includes("brands:");
    }
    
    return false; 
}
// function to check if has brand model year ends
// function returns 1st values of year like 2003 - 2010 will return 2003
function optimizeYear(year){
    if(year && year.includes("-")){
        let firstVal = year.slice(0,year.indexOf('-')).trim()
        let secondVal = year.slice(year.indexOf('-')+1).trim()
        // return `year >= ${firstVal} AND year <= ${secondVal}`
        return firstVal
    }
}
// function returns 1st values of year  ends
// function format the ai searched 
function removeEmptyFields(data){
    let filterData = Object.fromEntries(
       Object.entries(data).filter(([_, value]) => value !== "" && value !== null && value !== undefined && value !== "None" && value.length !== 0)
   )
   // now converting this optimized object to the searchable filters to format like
   // 'price <= 100 AND category : test'
   const { brand, model, year, category,sku } = filterData;
   let filtersFormatted = buildFilters(filterData)
   let filterString = filtersFormatted.filterString 
   // now make request to algoliya and search results accordingly
//    let newReqData = {...requestData}
   if(filtersFormatted.filterCount >= 1){
        requestData.query = ""
        if(filterString.includes("sku")){
            requestData.facetFilters = [`collection_ids:${collectionId}`] 
            requestData.query = "" 
            let newFilters = `sku:${sku} ${requestData.filters && typeof requestData.filters !== "undefined"  ?  `AND ${requestData.filters }` : ""}`
            requestData.filters = newFilters
            deboundHandleSort(sortBy.value,requestData,true)
            updateActiveFiltersDisplay()
            requestData.filters = ensurePriceGuard(newFilters);
        }
       else if(filterString.includes("brand") && filterString.includes("model") && filterString.includes("year") && filterString.includes("categories")){
            let filters = [`brands:${brand}`, `models:${model}`, `years:${year}`, `categories:${category}`]
            // requestData.facetFilters = [`brand_model_year:${brand}/${model}/${year}`,`categories:${category}`]
            requestData.facetFilters = filters
            setURLFilters(filters)
            requestData.query = ""
            requestData.filters = ""
            deboundHandleSort(sortBy.value,requestData,true)
            requestData.filters = ensurePriceGuard("");

       }
       else if(filterString.includes("brand") && filterString.includes("model") && filterString.includes("year")){
            // requestData.facetFilters = [`brand_model_year:${brand}/${model}/${year}`]
            let filters = [`brands:${brand}`, `models:${model}`, `years:${year}`]
            requestData.facetFilters = filters
            setURLFilters(filters)
            requestData.query = ""
            requestData.filters = ""
            deboundHandleSort(sortBy.value,requestData,true)
            requestData.filters = ensurePriceGuard("");

       }
       else{
            // requestData.facetFilters = [`brands:${brand ? brand : ""}`,`models:${model ? model : ""}`,`years:${year ? year : ""}`,`categories:${category ? category : ""}`]
            // else-grenen i removeEmptyFields:
let filters = [
  `vendor:${brand ? brand : ""}`,
  `models:${model ? model : ""}`,
  `years:${year ? year : ""}`,
  `categories:${category ? category : ""}`
];
requestData.facetFilters = filters;
setURLFilters(filters);
requestData.query = "";
requestData.filters = ensurePriceGuard("");   // <- IKKE newFilters her
deboundHandleSort(sortBy.value, requestData, true);
requestData.filters = ensurePriceGuard("");

       }
   }
   else{
        deboundHandleSort(sortBy.value,requestData,true)
   }
}
// function format the ai searched ends
// function  to build filters string from object
function buildFilters(filters) {
    const allowedFilters = ['brand', 'model', 'year', 'category','sku']; // List of valid filters
    const filterStrings = [];
    let filterCount = 0;
    // Loop through the filters object keys
    Object.keys(filters).forEach(filter => {
      if (filters[filter] && allowedFilters.includes(filter)) { // Only process valid filters
        // Adjust the key name dynamically if it's 'category'
        const filterKey = (filter === 'category') ? 'categories' : filter;
  
        if (Array.isArray(filters[filter])) {
          // Use OR for multiple values (correct format for Algolia)
          filterStrings.push(`(${filters[filter].map(value => `${filterKey}:${value}`).join(' OR ')})`);
          filterCount += filters[filter].length; // Count all values inside the array
        } else {
          // Handle single value
          filterStrings.push(`${filterKey}:${filters[filter]}`);
          filterCount++;
        }
      }
    });
    return {
      filterString: filterStrings.join(' AND '),
      filterCount
    };
  }
// function  to build filters string from object ends

// function optimize search with ai ends
// funtion to create Products UI that accepts products array as argument
function optimizeUrl(url) {
    let extensions = ['.jpeg', '.png', '.jpg'];
    if(url !== null){
        // Only apply _800x resize to product images, not /files/ URLs
        if(url.includes('/files/')) return url;
        for (let ext of extensions) {
            if (url.includes(ext)) {
                return url.replace(ext,`_800x${ext}`);
            }
        }
    }
    else if(url === null){
        return `https://cdn.shopify.com/s/files/1/0533/2089/files/placeholder-images-image_large.png?v=1530129081`
    }
    return url;
}
// function to create headings ui
function createHeadings(numPlate,BMY){
    let headingWrap = collectionPage ? collectionPage.querySelector(".page-hero-content-wrapper") : null 
    headingWrap.innerHTML = ""

    let BMYString = `${BMY[0]}/${BMY[1]}/${BMY[2]}`
    let heading = document.createElement("h1")
    let subHeading = document.createElement("span") 
    heading.classList = "page-hero-heading Filter_heading_custom"
    subHeading.classList = "sub_heading_collection_title"
    heading.append(numPlate)
    subHeading.append(BMYString)
    headingWrap.appendChild(heading)
    headingWrap.appendChild(subHeading)


}
// function to create headings ui ends
// function create default heading 
function createDefaultHeading(){
    let headingWrap = collectionPage ? collectionPage.querySelector(".page-hero-content-wrapper") : null 
    if(headingWrap){
        headingWrap.innerHTML = ""
        let heading = document.createElement("h1")
        heading.classList = "page-hero-heading Filter_heading_custom"
        heading.append("Produkter")
        headingWrap.appendChild(heading)
    }
}
// function extract metafild warehouse
function getWarehouseInfo(product) {
  const warehouseStockStatus = product && typeof product.warehouse_stock_status === 'string' ? product.warehouse_stock_status : null;

  if (!warehouseStockStatus || warehouseStockStatus.trim() === '') {
    return { quantity: null, expectedDate: null };
  }

  const parsedQuantity = parseInt(warehouseStockStatus, 10);

  if (!isNaN(parsedQuantity)) {
    return { quantity: parsedQuantity, expectedDate: null };
  }

  // Fallback: Try to extract a date like "07.02.2025"
  const dateMatch = warehouseStockStatus.match(/\b\d{2}\.\d{2}\.\d{4}\b/);

  if (dateMatch) {
    // Optional: Convert to required format "DD.MM.YYYY"
    const [day, month, year] = dateMatch[0].split('.');
    const formattedDate = `${day}.${month}.${year}`;
    return { quantity: null, expectedDate: formattedDate };
  }

  return { quantity: null, expectedDate: null };
}

// function check metafield ends
// function extract introduction 
function extractProductIntroduction(product) {
  // Step 1: Check if introduction exists in additional_data
  if (
    product.additional_data &&
    typeof product.additional_data === 'object' &&
    product.additional_data.introduction
  ) {
    return product.additional_data.introduction;
  }

  // Step 2: Fallback to metafields
  if (
    Array.isArray(product.metafields) &&
    product.metafields.length > 0 &&
    product.metafields[0].value
  ) {
    return product.metafields[0].value;
  }

  // Optional: Return a default message if nothing is found
  return 'No introduction available';
}
// function extract introduction ends
// function extract metafild warehouse ends
// function create default heading ends
function createProductsUi(products, productsCount, query) {
 console.log("query",query)
    let productsContent = ""
    if (productsCount === 0 || productsCount < 1) {
        productCount.innerHTML = ``
        productsContent = `<h2 class="no-products-h2">No products found</h2>`
    }
    else if (productsCount > 0) {
        productCount.innerHTML = `${productsCount} Produkter`
      
    //   products = products.filter(product => product.price >= 1 );
    //  let sortedProducts = products.sort((a, b) => {
    //       // Prioritize matching SKU
    //       if (a.sku === query && b.sku !== query) return -1;
    //       if (b.sku === query && a.sku !== query) return 1;
        
    //       // Otherwise sort by order_count descending
    //       return b.order_count - a.order_count;
    //     });
    //     console.log('sortedProducts' , (sortedProducts?.map(p => p.order_count)))
    //     console.log('sortedProducts' , (sortedProducts?.map(p => p.sku)))
        products.forEach((singleProduct, index) => {
            let price = singleProduct.variants.price ? singleProduct.variants.price : singleProduct.variants[0].node.price
            let compareAtPrice = singleProduct.variants.compareAtPrice ? singleProduct.variants.compareAtPrice : singleProduct.variants[0]?.node?.compareAtPrice
            let priceNumber = parseFloat(price);
            let compareAtPriceNumber = parseFloat(compareAtPrice);
            let variantId = singleProduct.variants.id ? singleProduct.variants.id : singleProduct.variants[0]?.node?.id
            let formattedVariantId = parseInt(variantId.replace('gid://shopify/ProductVariant/', ""))
            let formattedPrice = priceNumber.toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
            let optimizedUrl = optimizeUrl(singleProduct.image)
            let formattedCompareAtPrice = compareAtPriceNumber.toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
            let stockStatus = singleProduct.shopify_stock_status
            let wareHouseStatus = getWarehouseInfo(singleProduct)
            let productSku = singleProduct.variants.sku ? singleProduct.variants.sku : singleProduct.variants [0].node.sku
            let productIntroduction = extractProductIntroduction(singleProduct)

            // const additional_data_introduction = singleProduct?.additional_data?.introduction ?? "";
            // const custom_introduction = singleProduct.metafields.filter(
            //     intro => icustom_introductionntro.key === "product_introduction" && intro.namespace === "custom_intro"
            //     ).map(intro => intro.value);
                const metafields = singleProduct.metafields || [];
        const product_introduction = metafields.find(metafield => metafield.key === 'product_introduction');
        const custom_introduction = singleProduct.additional_data?.introduction || product_introduction?.value || '';

console.log("custom_introduction", custom_introduction)
            productsContent +=
                `
            <li class="grid-item">
                    <div class="card card-product card-product-no-rating color-background-2">
                        <figure class="card-media card-media-contain">
                            <a href="/products/${singleProduct.handle}">
                                <div class="aspect-ratio" style="--ratio-percent: 100%;">
                                    <img class="card-media-image" src="${optimizedUrl}" alt="${singleProduct.title}" width="950" height="950" loading="lazy" onerror="this.onerror=null;this.src='https://cdn.shopify.com/s/files/1/0533/2089/files/placeholder-images-image_large.png?v=1530129081';">
                                </div>
                            </a>
                             ${parseInt(compareAtPrice) > parseInt(price) ?
                    `<span class="sale_tag_card_per absolute_card-tag_media">-${Math.round(((parseInt(compareAtPrice) - parseInt(price)) * 100) / parseInt(compareAtPrice))}% Salg</span>`
                    : ''
                }
                        </figure>
                        <div class="card-info-wrap">
                            <div class="card-info">
                                <h3 class="card-heading typography-body">
                                    <a href="/products/${singleProduct.handle}">${singleProduct.title}</a>
                                </h3>
                                <span class="metafields_introducts new-metafields_introducts">${custom_introduction}</span>
                                 <span class="product-info-meta-item product-info-meta-item-code">
                          Varenr: <span id="ProductSku-template--17737542074592__product-grid">${productSku}</span>
                                </span>



                                 ${
                                    stockStatus >= 1 || (wareHouseStatus && wareHouseStatus.quantity >= 1) ?
                                    `
                                    <div class="stock_status_wrap stock_status_wrap--in">
                                      <span>
                                        <span class="badge-stock-icon pfu-stock-dot"></span>
                                        På lager
                                      </span>
                                    </div>
                                    `
                                    :
                                    stockStatus <= 0 && wareHouseStatus && wareHouseStatus.expectedDate ?
                                    `
                                    <div class="stock_status_wrap stock_status_wrap--expected">
                                      <span>
                                        <span class="badge-stock-icon pfu-stock-dot"></span>
                                        Forventet: ${wareHouseStatus.expectedDate}
                                      </span>
                                    </div>
                                    `
                                    :
                                    stockStatus <= 0 && wareHouseStatus && wareHouseStatus.quantity <= 0 ?
                                    `
                                    <div class="stock_status_wrap stock_status_wrap--out">
                                      <span>
                                        <span class="badge-stock-icon pfu-stock-dot"></span>
                                        Ikke på lager
                                      </span>
                                    </div>
                                    `
                                    : ``
                                  }




                                
                                 ${compareAtPrice > price ?
                            `<span class="sale_tag_card_per">-${Math.round(((parseInt(compareAtPrice) - parseInt(price)) * 100) / parseInt(compareAtPrice))}% Salg</span>`
                            : ''
                              }
                               
                            </div>
                            <div class="card-footer ${price === 0 || isNaN(price) ? 'hidden' : ""}">
                                <div class="price ${compareAtPrice > price ? "price-on-sale" : ""}">
                                    <div class="price-container">
                                        ${parseInt(compareAtPrice) > parseInt(price) ? `
                                        <div class="price-sale">
                                            <span class="visually-hidden">Vanlig pris</span>
                                            <span class="price-discount">
                                                <s class="price-item price-item-regular">${formattedCompareAtPrice} kr</s>
                                            </span>
                                            <span class="visually-hidden">Salgs pris</span>
                                            <span class="price-item price-item-sale price-item-last">
                                                ${formattedPrice} kr
                                                <span class="sup">inkl. mva</span>    
                                            </span>
                                        </div>` : `
                                        <div class="price-regular">
                                            <span class="visually-hidden">Vanlig pris</span>
                                            <span class="price-item price-item-regular">
                                                ${formattedPrice} kr
                                                <span class="sup">inkl. mva</span>
                                            </span>
                                        </div>`}
                                    </div>
                                </div>
                                <div class="card-floating-footer">
                                ${price > 0 || compareAtPrice > 0 ?
                                    `<product-form>
                                        <form method="post" action="/cart/add" id="product-form-${singleProduct.id}" accept-charset="UTF-8" class="shopify-product-form" enctype="multipart/form-data" novalidate="novalidate" data-type="add-to-cart-form" data-stock-threshold="3" data-event-context=" - Collection: 1-DIN Spillere">
                                            <input type="hidden" name="form_type" value="product">
                                            <input type="hidden" name="utf8" value="✓">
                                            <input type="hidden" name="id" value="${formattedVariantId}">
                                            <div class="product-actions card-product-actions">
                                                <div class="product-actions-add-to-cart">
                                                    <button type="submit" name="add" class="button button-secondary button-add-to-cart button-solid">
                                                        <span>Legg i handlekurv</span>
                                                        <div class="button-overlay-spinner hidden">
                                                            <span class="spinner-xs"></span>
                                                        </div>
                                                    </button>
                                                </div>
                                            </div>
                                            <div class="product-form-error-message-wrapper form-status form-status-error" role="alert" hidden="">
                                                <span class="product-form-error-message"></span>
                                            </div>
                                            <input type="hidden" name="product-id" value="8317999907040">
                                            <input type="hidden" name="section-id" value="template--17924865786080__product-grid">
                                        </form>
                                        </product-form>`
                            :
                            ""
                            }
                                </div>
                                <div class="card-list-floating-footer">
                                    <product-form class="product-form" data-hide-errors="">
                                        <div class="product-form-error-message-wrapper form-status form-status-error" role="alert"
                                            hidden="">
                                            <span class="product-form-error-message"></span>
                                        </div>
                                        <form method="post" action="/cart/add"  accept-charset="UTF-8"
                                            class="shopify-product-form" enctype="multipart/form-data" novalidate="novalidate"
                                            data-type="add-to-cart-form" data-stock-threshold="3"
                                            data-event-context=" - Collection: BILSTEREO">
                                            <input type="hidden" name="form_type" value="product">
                                            <input type="hidden" name="utf8" value="✓">
                                            <input type="hidden" name="id" value="${singleProduct.variants.id}">
                                            <div class="product-actions">
                                                <div class="product-actions-add-to-cart
                                            product-actions-add-to-cart-solid
                                                product-actions-add-to-cart-quantity
                                            
                                            
                                            ">
                                                    <quantity-input class="quantity-input">
                                                        <button type="button" name="minus"
                                                            class="quantity-input-button quantity-input-minus no-js-hidden">
                                                            −
                                                            <span class="visually-hidden">Reduser mengden for Pioneer MVH330DAB, kort
                                                                chassis</span>
                                                        </button>
                                                        <label for="quantity-input-template--${singleProduct.id}__product-grid"
                                                            class="visually-hidden">Antall</label>
                                                        <input name="quantity" type="number" class="quantity-input-field"
                                                            id="quantity-input-template--${singleProduct.id}__product-grid" min="1" value="1">
                                                        <button type="button" name="plus"
                                                            class="quantity-input-button quantity-input-plus no-js-hidden">
                                                            +
                                                            <span class="visually-hidden">Øk mengden for Pioneer MVH330DAB, kort
                                                                chassis</span>
                                                        </button>
                                                    </quantity-input>
                    
                                                    <button type="submit" name="add"
                                                        class="button button-secondary button-add-to-cart"><span>Legg til i
                                                            handlekurv</span>
                                                        <div class="button-overlay-spinner hidden">
                                                            <span class="spinner-xs"></span>
                                                        </div>
                                                    </button>
                                                </div>
                                            </div>
                                            <input type="hidden" name="product-id" value="${singleProduct.variants.id}"><input type="hidden"
                                                name="section-id" value="template--${singleProduct.id}__product-grid">
                                        </form>
                                    </product-form>
                                </div>
                            </div>
                        </div>
                    </div>
                </li>
            `

        })
    }
    productGrid.innerHTML = productsContent
}
// function product UI ends here

// Hvor mange filtervalg som skal vises før "Vis mer"
const MAX_VISIBLE_FACET_ITEMS = 10;

function attachShowMoreButton(ul) {
  const items = ul.querySelectorAll('li');
  if (!items || items.length <= MAX_VISIBLE_FACET_ITEMS) return; // ikke behov

  // Skjul alt over grensen
  items.forEach((li, i) => {
    if (i >= MAX_VISIBLE_FACET_ITEMS) li.classList.add('facet-hidden');
  });

  // Lag footer + knapp
  const footer = document.createElement('div');
  footer.className = 'facet-content-footer';

  const btn = document.createElement('button');
  btn.type = 'button';
  btn.className = 'button-text-link facet-button-more';
  btn.textContent = '+ Vis mer';
  btn.setAttribute('aria-expanded', 'false');
  btn.setAttribute('data-state', 'collapsed');

  footer.appendChild(btn);

  // Legg footer etter ul (inne i .facet-content)
  const facetContent = ul.parentElement; // .facet-content
  facetContent.appendChild(footer);

  // Toggle logikk
  btn.addEventListener('click', () => {
    const collapsed = btn.getAttribute('data-state') === 'collapsed';
    if (collapsed) {
      items.forEach((li, i) => { if (i >= MAX_VISIBLE_FACET_ITEMS) li.classList.remove('facet-hidden'); });
      btn.textContent = '− Vis mindre';
      btn.setAttribute('data-state', 'expanded');
      btn.setAttribute('aria-expanded', 'true');
    } else {
      items.forEach((li, i) => { if (i >= MAX_VISIBLE_FACET_ITEMS) li.classList.add('facet-hidden'); });
      btn.textContent = '+ Vis mer';
      btn.setAttribute('data-state', 'collapsed');
      btn.setAttribute('aria-expanded', 'false');
    }
  });
}

function applyFacetShowMore() {
  document
    .querySelectorAll('.facet-options-list.custom-filters-list')
    .forEach(ul => attachShowMoreButton(ul));
}

// funtion to create filters UI
function createFilterUi(filters, facetStats) {
    console.log("filters",filters.tags)
    let arraytags= objectToArray(filters.tags)
    console.log("arraytags",arraytags)
    // here creating variables to store that data of filters
    let filterContent = "";
    let metaFieldTags = window.storeMetafields.facets.filters
    let priceFilterContent = ""
    let maxPrice = (facetStats && facetStats.price && facetStats.price.max) ? facetStats.price.max : 0;
    filters = objectToArray(filters)
    // creating html for price filter
    priceFilterContent = `
              <div class="js-filter  price_filter">
                  <div>
                      <collapsible-expandable expanded="true">
                          <div class="facet">
                              <button class="facet-toggle" type="button" aria-expanded="true">
                                  <span>Pris</span>
                                  <span class="angle angle-down">
                                      <span class="angle-icon"></span>
                                  </span>
                              </button>
                              <div class="facet-content">
                                  <div class="facet-content-header js-price-range-header">
                                      <span>Høyeste pris er ${maxPrice} kr</span>
                                  </div>
                                  <price-range>
                                      <div class="facets-price-range">
                                          <div class="facet-price-range-field">
                                              <span class="facet-price-range-currency">kr</span>
                                              <label for="Pris-from" class="visually-hidden">Fra</label>
                                              <input class="price-inputs-filters" type="number" id="min-read-price" name="filter.v.price.gte" placeholder="Fra" min="0" value="" max="${maxPrice} " >
                                          </div>
                                          <div class="facet-price-range-field">
                                              <span class="facet-price-range-currency">kr</span>
                                              <label for="Pris-to" class="visually-hidden">Til</label>
                                              <input class="price-inputs-filters" type="number"  id="max-read-price" name="filter.v.price.lte"  max="${maxPrice} " placeholder="Til" value="${""}" min="0"  >
                                          </div>
                                      </div>
                                  </price-range>
                              </div>
                              <div class="range-slider">
                                <span class="hidden">
                                  <input class="min-number-range" type="number" value="0" min="0" max="44">
                                  <input class="max-number-range" type="number" value="54.00" min="21" max="54.00">
                                </span>
                                                       
                                <input id="Pris-from" name="filter.v.price.gte" value="0" min="0" max="${maxPrice}" step="100" type="range">
                                <span id="range-min-tooltip" style="left: 81.4815%;">$<span>21</span></span>              
                                <input id="Pris-to" name="filter.v.price.lte" value="${maxPrice}" min="0" max="${maxPrice}" step="100" type="range">
                                <span id="range-max-tooltip" style="left: 38.8889%;">$<span>21</span></span> 
                                 
                              </div>
                              
                               <div class="price-ranges ">
                               <span>0</span>
                               <span>${maxPrice}</span>
                               </div>
                              
                          </div>
                      </collapsible-expandable>
                      
                  </div>
              </div>`;
    filters.forEach(function (filter) {
        console.log("filter",filter)
        // if name of filter is tagss? then we will match the tags with metaFilters we have and show accordingly
        if (filter.name == "tags") {
            metaFieldTags.forEach(metaFilter => {
                // match meta array with facet tags
                let matchedArray = matchArray(filter.value, metaFilter.tags)
                console.log("matchedArray",matchedArray)
                if (matchedArray.length > 0) {
                    filterContent += `
                    <div class="js-filter">
                        <div>
                            <collapsible-expandable expanded="true">
                                <div class="facet">
                                    <button class="facet-toggle" type="button" aria-expanded="true">
                                        <span>${metaFilter.label}</span>
                                        <span class="angle angle-down">
                                            <span class="angle-icon"></span>
                                        </span>
                                    </button>
                                    <div class="facet-content">
                                        <ul class="facet-options-list custom-filters-list" aria-expanded="false">`;
                                                let Tags_Count = 0;
                                                matchedArray
                                                .sort((a, b) => {
                                                const nameA = a.name.toLowerCase();
                                                const nameB = b.name.toLowerCase();

                                                const numA = parseFloat(nameA);
                                                const numB = parseFloat(nameB);
                                                const hasNumA = !isNaN(numA);
                                                const hasNumB = !isNaN(numB);

                                                const hasX_A = nameA.includes('x');
                                                const hasX_B = nameB.includes('x');

                                                // Hvis bare én av dem har "x" → legg den med "x" sist
                                                if (hasX_A && !hasX_B) return 1;
                                                if (!hasX_A && hasX_B) return -1;

                                                // Hvis begge har tall → sorter numerisk
                                                if (hasNumA && hasNumB) return numA - numB;

                                                // Hvis bare én har tall → tall først
                                                if (hasNumA && !hasNumB) return -1;
                                                if (!hasNumA && hasNumB) return 1;

                                                // Ellers alfabetisk
                                                return nameA.localeCompare(nameB, 'no', { sensitivity: 'base' });
                                                })


                                                .forEach(function (singleTag) {
                                                    console.log("singleTag",singleTag)
                                                                        const count = Number(singleTag.value || 0);
                                                const isDisabled = count === 0;

                                                filterContent += `
                                                <li class="facet-options-list-item">
                                                    <span class="checkbox-facet">
                                                    <label class="checkbox-facet-label ${isDisabled ? 'is-disabled' : ''}">
                                                        <input
                                                        ${isDisabled ? 'disabled' : ''}
                                                        data-filter=${metaFilter.label}
                                                        name="ttr_${singleTag.name}"
                                                        value="${singleTag.name.replace('"', '&quot;')}"
                                                        active="tags"
                                                        filter-base="base OR or AND"
                                                        class="new-filter-input"
                                                        type="checkbox"
                                                        />
                                                        <span class="checkbox-facet-check"></span>
                                                        <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M17.5303 9.53033C17.8232 9.23744 17.8232 8.76256 17.5303 8.46967C17.2374 8.17678 16.7626 8.17678 16.4697 8.46967L17.5303 9.53033ZM9.99998 16L9.46965 16.5304C9.76255 16.8232 10.2374 16.8232 10.5303 16.5303L9.99998 16ZM7.53027 12.4697C7.23737 12.1768 6.7625 12.1768 6.46961 12.4697C6.17671 12.7626 6.17672 13.2374 6.46961 13.5303L7.53027 12.4697ZM16.4697 8.46967L9.46965 15.4697L10.5303 16.5303L17.5303 9.53033L16.4697 8.46967ZM6.46961 13.5303L9.46965 16.5304L10.5303 15.4697L7.53027 12.4697L6.46961 13.5303Z"></path>
                                                        </svg>
                                                        <span class="checkbox-facet-label-text">${singleTag.name}</span>
                                                        <span class="checkbox-facet-label-count">${count}</span>
                                                    </label>
                                                    </span>
                                                </li>`;

                                            });
                                            filterContent += `
                                        </ul>
                                 </div>
                                 </div>
                                  </collapsible-expandable>
                        </div>
                        </div>`;
                }
            })
        }
        else {
            let filterTags = filter.value;
// Gi pen overskrift for kjente feltnavn
const labelMap = { vendor: "Varemerke" };
let filterLabel = labelMap[filter.name] || filter.name;

            // creating html for filters that we get from filter
            filterContent += `
            <div class="js-filter">
                <div>
                    <collapsible-expandable expanded="true">
                        <div class="facet">
                            <button class="facet-toggle" type="button" aria-expanded="true">
                                <span>${filterLabel}</span>
                                <span class="angle angle-down">
                                    <span class="angle-icon"></span>
                                </span>
                            </button>
                            <div class="facet-content">
                                <ul class="facet-options-list custom-filters-list" aria-expanded="false">`;
            let Tags_Count = 0;
            filterTags
  .sort((a, b) => {
  const nameA = a.name.toLowerCase();
  const nameB = b.name.toLowerCase();

  const numA = parseFloat(nameA);
  const numB = parseFloat(nameB);
  const hasNumA = !isNaN(numA);
  const hasNumB = !isNaN(numB);

  const hasX_A = nameA.includes('x');
  const hasX_B = nameB.includes('x');

  // Hvis bare én av dem har "x" → legg den med "x" sist
  if (hasX_A && !hasX_B) return 1;
  if (!hasX_A && hasX_B) return -1;

  // Hvis begge har tall → sorter numerisk
  if (hasNumA && hasNumB) return numA - numB;

  // Hvis bare én har tall → tall først
  if (hasNumA && !hasNumB) return -1;
  if (!hasNumA && hasNumB) return 1;

  // Ellers alfabetisk
  return nameA.localeCompare(nameB, 'no', { sensitivity: 'base' });
})


  .forEach(function (singleTag) {

                // let lengthTags = Object.keys(filterTags).length
                const count = Number(singleTag.value || 0);
const isDisabled = count === 0;

filterContent += `
  <li class="facet-options-list-item">
    <span class="checkbox-facet">
      <label class="checkbox-facet-label ${isDisabled ? 'is-disabled' : ''}">
        <input
          ${isDisabled ? 'disabled' : ''}
          data-filter=${filter.name}
          name="ttr_${singleTag.name}"
          value="${singleTag.name}"
          active="${filter.name}"
          filter-base="base OR or AND"
          class="new-filter-input"
          type="checkbox"
        />
        <span class="checkbox-facet-check"></span>
        <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <path d="M17.5303 9.53033C17.8232 9.23744 17.8232 8.76256 17.5303 8.46967C17.2374 8.17678 16.7626 8.17678 16.4697 8.46967L17.5303 9.53033ZM9.99998 16L9.46965 16.5304C9.76255 16.8232 10.2374 16.8232 10.5303 16.5303L9.99998 16ZM7.53027 12.4697C7.23737 12.1768 6.7625 12.1768 6.46961 12.4697C6.17671 12.7626 6.17672 13.2374 6.46961 13.5303L7.53027 12.4697ZM16.4697 8.46967L9.46965 15.4697L10.5303 16.5303L17.5303 9.53033L16.4697 8.46967ZM6.46961 13.5303L9.46965 16.5304L10.5303 15.4697L7.53027 12.4697L6.46961 13.5303Z"></path>
        </svg>
        <span class="checkbox-facet-label-text">${singleTag.name}</span>
        <span class="checkbox-facet-label-count">${count}</span>
      </label>
    </span>
  </li>`;


            });
            filterContent += `
            </ul>
                </div>
                </div>
                </collapsible-expandable>
                </div>
                </div>`;
        }
        //         VIEW MORE BTNNN
        // ${filter.value.length > 9 ?  `<div class="facet-content-footer">
        //     <button class="button-text-link facet-button-more" type="button" form="FacetsFilterForm">+ Vis mindre</button>
        //     </div>`: ''}
    });
    // appending the html in mblfilter variable
    // mblFilter.innerHTML = filterContent + priceFilterContent
    mblFilter.innerHTML = filterContent  + priceFilterContent
    let fullString = productCount.textContent ? productCount.textContent : "noproducts" 
    let countToNumber = parseInt(fullString.slice(0, fullString.indexOf(" ")), 10);
    // if(countToNumber > 0 ){
    //     mblFilter.innerHTML += priceFilterContent
    // }
    const checkboxes = collectionPage ? collectionPage.querySelectorAll('input.new-filter-input') : null;
    if (checkboxes.length > 0) {
        // getting filters from URL with getUrlFilters function
        let filters = getUrlFilters()
        // now calling that syncchecbox function and passing filters that we got
        if(filters && filters !== ""){
            syncCheckboxesWithFilters(filters)
        }
        // getting checked checkbox and pass it in function below (updateActiveFiltersDisplay)
        let checboxCheked = document.querySelectorAll(".new-filter-input:checked")
        updateActiveFiltersDisplay(checboxCheked)
        checkboxes.forEach(function (checkbox) {
            checkbox.addEventListener('change', function () {
                handleCheckboxChange();
            });
        });
    }
    if (sideBar) {
        sideBar.classList.remove("page-layout-sidebar")
    }
    else {
        document.querySelector(".default-layout-sidebar").classList.remove("page-layout-sidebar")
    }
    //   add event listner to the price range inputs
    document.querySelectorAll(".price-inputs-filters").forEach(btn => {
        btn.addEventListener("input", () => {
                debouncedHandlePriceRange()
        })
    })
    let priceFilters = getPriceFilters()
    if (priceFilters) {
        let result = priceFilters.map(str => parseInt(str.split('=')[1], 10));
        document.getElementById("min-read-price").value = result[0]
        document.getElementById("max-read-price").value = result[1]
    }
    applyFacetShowMore();
}
// function handle price range
function handlePriceRange() {
  const minEl = document.getElementById("min-read-price");
  const maxEl = document.getElementById("max-read-price");
  const min = Number(minEl.value);
  const max = Number(maxEl.value);
  const hasMin = minEl.value !== "" && !Number.isNaN(min);
  const hasMax = maxEl.value !== "" && !Number.isNaN(max);

  const skuFilter =
    (requestData.filters && requestData.filters.includes("sku:"))
      ? requestData.filters.slice(requestData.filters.indexOf("sku"), requestData.filters.indexOf(" ") > -1 ? requestData.filters.indexOf(" ") : undefined).trim()
      : "";

  let priceExpr = "";
  if (hasMin && hasMax) {
    priceExpr = `price >= ${min} AND price <= ${max}`;
    setPriceFilters([`min=${min}`, `max=${max}`]);
  } else if (hasMin) {
    priceExpr = `price >= ${min}`;
    setPriceFilters([`min=${min}`, `max=none`]);
  } else if (hasMax) {
    priceExpr = `price <= ${max}`;
    setPriceFilters([`min=none`, `max=${max}`]);
  } else {
    setPriceFilters("");
  }

  requestData.filters = ensurePriceGuard((skuFilter ? `${skuFilter}${priceExpr ? " AND " : ""}` : "") + priceExpr);
  handleCheckboxChange();
}

// function handle price range ends
// funtion to convert checkbox values array to facets filters
// OR innen samme filter, AND mellom ulike filterfelter
function convertToFacetFilters(dataArray, collectionId) {
  // Gruppér valgte verdier pr. attributt
  const grouped = dataArray.reduce((acc, item) => {
    const key = item.filterName; // f.eks. "tags", "vendor"
    if (!acc[key]) acc[key] = new Set();
    acc[key].add(item.value);
    return acc;
  }, {});

  // Start alltid med collection-id som AND
  const facetFilters = [`collection_ids:${collectionId}`];

  // Legg på hvert attributt:
  // - Én verdi  -> vanlig streng (AND)
  // - Flere     -> array av strenger (OR)
  for (const [attr, set] of Object.entries(grouped)) {
    const values = Array.from(set).map(v => `${attr}:${v}`);
    facetFilters.push(values.length === 1 ? values[0] : values);
  }

  return facetFilters;
}

// Gjør facetFilters fra URL om til en flat liste med strenger
function flattenUrlFilters(filters) {
  const out = [];
  (filters || []).forEach(f => {
    if (Array.isArray(f)) out.push(...f);
    else if (typeof f === 'string') out.push(f);
  });
  return out;
}

// funtion to convert checkbox values array to facets filters enddsss
// function to check url filters include brand model year?
function includingBMY(){
  const flat = flattenUrlFilters(getUrlFilters());
  const hasUrlBmy = flat.some(str => typeof str === 'string' && (str.startsWith('brand_model_year:') || str.startsWith('brands:')));
  const hasIdFilter = requestData.filters && requestData.filters.includes('id =');
  return hasUrlBmy || hasIdFilter;
}

// function to check url filters include brand model year? ends
// funtion to handle checkbox 
function handleCheckboxChange() {
    // getting all the input checkbox that are ?checked
    const checkedCheckboxes = collectionPage.querySelectorAll('input.new-filter-input:checked');
    // creating array of objects of each checkbox values like value,name,filtername,filterBase
    const checkedValues = Array.from(checkedCheckboxes).map(checkbox => ({
        value: checkbox.value,
        name: checkbox.getAttribute('name'),
        filterName: checkbox.getAttribute('active'),
        filterBase: checkbox.getAttribute('filter-base')
    }));
    let selectedSort = sortBy ? sortBy.value : '';
    // updating the page every time the checkbox is clicked
    requestData.page = 0
    setPageToUrl(1)
    // here converting the total products count to number and removing the products string and assign it to countToNumber
    let fullString = productCount.textContent
    let countToNumber = parseInt(fullString.slice(0, fullString.indexOf(" ")), 10);
    // making count to number 0 if there is no products found
    if (productCount.firstElementChild?.classList?.contains("no-products")) {
        countToNumber = 0
    }
    // if checkboxes or any checbox is checked then we again call algoliya api and pass facets filter 
    updateActiveFiltersDisplay(checkedCheckboxes)
    if (checkedValues.length > 0) {
        console.log("chkbox length grt thn 0")
        // convert checked values to correct format to pass in algolia
        const facetFilters = convertToFacetFilters(checkedValues, collectionId);
        let urlFilter
        let facetFiltersNew  = []
        if(getUrlFilters().length > 0 && includingBMY() && requestData.facetFilters.length > 1 ){
            console.log("chkbox length grt thn 0 -> 1")
            urlFilter = []; // Car filter handled via API id-filter in requestData.filters
            facetFiltersNew = [...facetFilters, ...urlFilter,...requestData.facetFilters];
            requestData.facetFilters = facetFiltersNew
            setURLFilters(facetFiltersNew)
        }
        else if(getUrlFilters().length > 0 && includingBMY() ){
            console.log("chkbox length grt thn 0 -> 2")
            urlFilter = []; // Car filter handled via API id-filter in requestData.filters
            facetFiltersNew = [...facetFilters, ...urlFilter];
            requestData.facetFilters = facetFiltersNew
            setURLFilters(facetFiltersNew)
        }
        else{
            console.log("chkbox length grt thn 0 -> 3")
            // updating url with filters
            // if(requestData.facetFilters.length > 1){
            //     console.log("chkbox length grt thn 0 -> 3-> 1")
            //     let newFacetFilters = [...facetFilters,...requestData.facetFilters]
            //     let nonDuplicateFacets = removeDuplicateKeyValuePairs(newFacetFilters)
            //     requestData.facetFilters = nonDuplicateFacets
            //     setURLFilters(nonDuplicateFacets)
            // }
            // searching the records based on selected facets
            
            requestData.facetFilters = facetFilters
            setURLFilters(facetFilters)
        }

        // new added code below
        handleSortChange(selectedSort, requestData, false, requestData.query)
       

    }
    // if checkvalues length 0 and default count of product is greater than the current count, then call algoliya api again to remove filters and show all records
    else if (checkedValues.length === 0 && defaultProductCount > countToNumber  ) {
        console.log("2")
        requestData.facetFilters = ""
        let facetFilters = [`collection_ids:${collectionId}`]
        if(getUrlFilters().length > 0 && includingBMY()){
            let urlFilter = []; // Car filter handled via API id-filter in requestData.filters
            let facetFiltersNew  = []
             facetFiltersNew = [...facetFilters, ...urlFilter];
             requestData.facetFilters = facetFiltersNew
             setURLFilters(requestData.facetFilters)
             handleSortChange(selectedSort, requestData, true, requestData.query )
            }
            else{
                requestData.facetFilters = facetFilters
                setURLFilters(requestData.facetFilters)
                handleSortChange(selectedSort, requestData, false, requestData.query)
            }
        }
        else if (checkedValues.length === 0 && getPriceFilters().length > 0 ) {
            requestData.facetFilters = ""
            let facetFilters = [`collection_ids:${collectionId}`]
            if(getUrlFilters() && includingBMY()){
                let urlFilter = []; // Car filter handled via API id-filter in requestData.filters
                let facetFiltersNew  = []
                facetFiltersNew = [...facetFilters, ...urlFilter];
                requestData.facetFilters = facetFiltersNew
                setURLFilters(requestData.facetFilters)
                handleSortChange(selectedSort, requestData, true, requestData.query)
            }
            else{
                requestData.facetFilters = facetFilters
                setURLFilters(requestData.facetFilters)
                handleSortChange(selectedSort, requestData, false, requestData.query)
            }
        }
        else if (checkedValues.length === 0 && getPriceFilters().length < 1) {
            requestData.facetFilters = ""
            let facetFilters = [`collection_ids:${collectionId}`]
            if(getUrlFilters() && includingBMY()){
                let urlFilter = []; // Car filter handled via API id-filter in requestData.filters
            let facetFiltersNew  = []
             facetFiltersNew = [...facetFilters, ...urlFilter];
             requestData.facetFilters = facetFiltersNew
             setURLFilters(requestData.facetFilters)
             handleSortChange(selectedSort, requestData, true, requestData.query)
                
        }
        else{
            requestData.facetFilters = [`collection_ids:${collectionId}`]
            setURLFilters(requestData.facetFilters)
            handleSortChange(selectedSort, requestData, false, requestData.query)
            
        }
    }
    console.log(requestData.filters)
}
// function handle checkbox endss
// fun to remove duplicate key value 
function removeDuplicateKeyValuePairs(arr) {
    const uniqueSet = new Set();
    return arr.filter(item => {
        if (!uniqueSet.has(item)) {
            uniqueSet.add(item);
            return true;
        }
        return false;
    });
}
// fun to remove duplicate key value ends
// function removeFilter
function removeFilter(filter, value) {
    const checkbox = document.querySelector(`input.new-filter-input[name="${filter}"][value='${value}']`);
    if (checkbox) {
        checkbox.checked = false;
    }
    // call handlecheckbox so products fet filtered based on checkboxes that are checked
    handleCheckboxChange();
}
// function removeFilter ends
// function to create active filters UI
function updateActiveFiltersDisplay(checkedCheckboxes) {
    const activeFiltersContainer = document.getElementById('active-filters');
    if (activeFiltersContainer) { activeFiltersContainer.innerHTML = ''; } // Clear existing active filters

    // Display checked checkboxes
    if (checkedCheckboxes) {
        checkedCheckboxes.forEach(checkbox => {
            const checkName = checkbox.getAttribute('name');
            const checkActiveName = checkbox.dataset.filter;
            const filterValue = checkbox.value;
            const groupName = checkbox.dataset.groupName || 'Filter'; // Assuming checkboxes have a data-group-name attribute
            const filterTag = document.createElement('span');
            filterTag.className = 'active-filter';
            filterTag.innerHTML = `<span class="active_label_name">${checkActiveName}:</span>  ${filterValue} <button class="remove-filter" data-filter="${checkName}" data-value='${filterValue}'><svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M7.41401 6.00001L11.707 1.70701C12.098 1.31601 12.098 0.684006 11.707 0.293006C11.316 -0.0979941 10.684 -0.0979941 10.293 0.293006L6.00001 4.58601L1.70701 0.293006C1.31601 -0.0979941 0.684006 -0.0979941 0.293006 0.293006C-0.0979941 0.684006 -0.0979941 1.31601 0.293006 1.70701L4.58601 6.00001L0.293006 10.293C-0.0979941 10.684 -0.0979941 11.316 0.293006 11.707C0.488006 11.902 0.744006 12 1.00001 12C1.25601 12 1.51201 11.902 1.70701 11.707L6.00001 7.41401L10.293 11.707C10.488 11.902 10.744 12 11 12C11.256 12 11.512 11.902 11.707 11.707C12.098 11.316 12.098 10.684 11.707 10.293L7.41401 6.00001Z" fill="#3D4246"></path></svg></button>`;
            if (activeFiltersContainer) { activeFiltersContainer.appendChild(filterTag); }
        });
        // Show/Hide "Clear All" button
        const clearAllButtonActive = document.querySelector('#active-filters-container #clear-all-filters');
        if (checkedCheckboxes.length > 0) {
            clearAllButtonActive.classList.remove('hidden');
        } else {
            clearAllButtonActive.classList.add('hidden');
        }

        // Attach event listeners to remove filter buttons
        document.querySelectorAll('.remove-filter').forEach(button => {
            const newButton = button.cloneNode(true); // Clone button to remove listeners
            button.replaceWith(newButton); // Replace with a fresh element
            newButton.addEventListener('click', function () {
                removeFilter(this.dataset.filter, this.dataset.value);
            });
        });
    }
    // if we have request data filters then create active filter of price range too
    const hasUserPrice =
  (getPriceFilters()?.length || 0) > 0 || /\bprice\s*(>=|<=)/.test(requestData.filters || "");

if (hasUserPrice) {
        let str = requestData.filters
        let min = null
        let max = null
        // checking if it containing AND , then it is both min and max filters
        if (str.includes("AND")) {
            min = str.slice(str.indexOf(">=") + 2, str.indexOf("AND"))
            max = str.slice(str.indexOf("<=") + 2)
        }
        // if not containing and then its one of them
        else {
            // if includes >=  then it is min filter
            if (str.includes('>=')) {
                min = str.slice(str.indexOf(">=") + 2)
            }
            // if includes <= than its max
            else if (str.includes('<=')) {
                max = str.slice(str.indexOf("<=") + 2)
            }
        }
        // converting both to number
        let minNumber = parseFloat(min)
        let maxNumber = parseFloat(max)
        // chking types if they aren't number, just set unset in value
        if (typeof minNumber !== "number" || isNaN(minNumber)) {
            minNumber = "Unset"
        }
        // chking types if they aren't number, just set unset in value
        if (typeof maxNumber !== "number" || isNaN(maxNumber)) {
            maxNumber = "Unset"
        }
        let formattedMin = minNumber.toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        let formattedMax = maxNumber.toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        const filterTag = document.createElement('span');
        filterTag.className = 'active-filter';
        filterTag.innerHTML = `<span class="active_label_name">${"Price Filter"}:</span>Min:${formattedMin == "Unset" ? "Unset" : `${formattedMin}kr`} Max:${formattedMax == "Unset" ? "Unset" : `${formattedMax}kr`} <button class="remove-filter" data-filter="${"price_range"}" data-value='${"price_range"}'><svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M7.41401 6.00001L11.707 1.70701C12.098 1.31601 12.098 0.684006 11.707 0.293006C11.316 -0.0979941 10.684 -0.0979941 10.293 0.293006L6.00001 4.58601L1.70701 0.293006C1.31601 -0.0979941 0.684006 -0.0979941 0.293006 0.293006C-0.0979941 0.684006 -0.0979941 1.31601 0.293006 1.70701L4.58601 6.00001L0.293006 10.293C-0.0979941 10.684 -0.0979941 11.316 0.293006 11.707C0.488006 11.902 0.744006 12 1.00001 12C1.25601 12 1.51201 11.902 1.70701 11.707L6.00001 7.41401L10.293 11.707C10.488 11.902 10.744 12 11 12C11.256 12 11.512 11.902 11.707 11.707C12.098 11.316 12.098 10.684 11.707 10.293L7.41401 6.00001Z" fill="#3D4246"></path></svg></button>`;
        if (activeFiltersContainer) { activeFiltersContainer.appendChild(filterTag); }
    }
}
// function endss
// remove price filter
function removePriceFilter() {
    if(requestData.filters?.includes("sku")){
        // extract sku here
        let skuFilter = requestData.filters.slice(requestData.filters.indexOf("sku"),requestData.filters.indexOf(" ")+1)
        console.log(skuFilter)
        requestData.filters = ""
        requestData.filters = skuFilter
        setPriceFilters("")
        handleCheckboxChange()
        document.getElementById("min-read-price").value = ""
        document.getElementById("max-read-price").value = ""
    }
    else{
        requestData.filters = ""
        setPriceFilters("")
        handleCheckboxChange()
        document.getElementById("min-read-price").value = ""
        document.getElementById("max-read-price").value = ""
    }
}
// remove price filter ends
// adding event listner to clear all buttons
document.addEventListener("click", function (event) {
    if (event.target.matches('#clear-all-filters') || event.target.closest('#clear-all-filters')) {
        event.preventDefault();
        document.querySelectorAll('input.new-filter-input:checked').forEach((checkbox) => {
            checkbox.checked = false;
        });
        removePriceFilter()  // Call only once after unchecking all checkboxes
        // handleCheckboxChange(); // Call only once after unchecking all checkboxes
    }
});
// adding event listner to sidebar close btns 
document.addEventListener("click", function (event) {
    if (event.target.matches('.close_side_bar_filters') || event.target.closest('.close_side_bar_filters')) {
        event.preventDefault();
        sideBar.classList.remove("opened")
    }
});
document.addEventListener("click", function (event) {
    let classes = ['search', 'field', 'search-input-field', 'main', 'collection-actions-secondary', 'collection-actions-secondary-heading', 'collection-hero-banner-heading', 'card-info', 'card', 'card-product', 'container']
    if (classes.includes(event.target.classList[0]) && sideBar.classList.contains("opened")) {
        sideBar.classList.remove("opened")
    }
});
// event listner for the price filter remove
document.addEventListener("click", function (event) {
    if (event.target.dataset.filter === "price_range" || event.target.closest("[data-filter='price_range']")) {
        event.preventDefault();
        removePriceFilter()  // Call only once after unchecking all checkboxes
        // handleCheckboxChange(); // Call only once after unchecking all checkboxes
    }
});

// function get page number
function getPageFromUrl() {
    const urlParams = new URLSearchParams(window.location.search); // Get URL parameters
    const page = urlParams.get('page'); // Extract 'page' parameter
    return page ? parseInt(page, 10) : 1; // Default to 1 if 'page' is not in the URL
}
// function get page number endss
// function  set page to url
function setPageToUrl(page) {
    const urlParams = new URLSearchParams(window.location.search); // Get URL parameters
    urlParams.set('page', page); // Set or update the 'page' parameter
    const newUrl = window.location.pathname + '?' + urlParams.toString(); // Reconstruct the URL
    window.history.replaceState(null, '', newUrl); // Update the URL without reloading the page
}
// function  set page to url ends
// // set Ai to Url
// function setEnabledAiUrl(val) {
//     const urlParams = new URLSearchParams(window.location.search); // Get URL parameters
//     urlParams.set('ai_enabled', val); // Set or update the 'ai_enabled' parameter
//     const newUrl = window.location.pathname + '?' + urlParams.toString(); // Reconstruct the URL
//     window.history.replaceState(null, '', newUrl); // Update the URL without reloading the page
// }
// // set Ai to Url ends
// // get ai enabled from url
// function getEnabledAiUrl() {
//     const urlParams = new URLSearchParams(window.location.search); // Get URL parameters
//     const aiEnabled = urlParams.get('ai_enabled'); // Extract 'ai_enabled' parameter
//     return aiEnabled;
// }
// // get ai enabled from url ends
// function to update url with facets filters
function setURLFilters(filters) {
    const params = new URLSearchParams(window.location.search);
    // Add filters to the URL (e.g., filters as an array)
    params.set('filters', JSON.stringify(filters));
    // Update the URL without reloading the page
    window.history.replaceState(null, '', `?${params.toString()}`);
};
// function to retrieve facets filters from url
function getUrlFilters() {
    const params = new URLSearchParams(window.location.search);
    // Parse filters from the URL
    const filters = params.get('filters') ? JSON.parse(params.get('filters')) : [];
    return filters;
};
// get url facets filters ends
// function to set query filters
function setPriceFilters(filters) {
    const params = new URLSearchParams(window.location.search);
    // Add filters to the URL (e.g., filters as an array)
    params.set('price_range', JSON.stringify(filters));
    // Update the URL without reloading the page
    window.history.replaceState(null, '', `?${params.toString()}`);
};
// function to set query filters ends
function getPriceFilters() {
    const params = new URLSearchParams(window.location.search);
    // Parse filters from the URL
    const filters = params.get('price_range') ? JSON.parse(params.get('price_range')) : [];
    return filters;
};
// function to get query filters 

// function to get query filters ends
// function to set sortby in the url
function setURLSortBy(sortby) {
    const params = new URLSearchParams(window.location.search);
    // Add or update the sortby filter in the URL
    params.set('sortby', sortby);
    // Update the URL without reloading the page
    window.history.replaceState(null, '', `?${params.toString()}`);
}
// function to set sortby in the url ends
// function to get sortby filter from url
function getURLSortBy() {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get('sortby'); // Returns the value of 'sortby', or null if not present
}
// function to get sortby filter from url ends
// function to get url query 
function getUrlSearchQ() {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get('q');
}
// function to get url query ends
// function to set url query 
function setUrlSearchQ(value) {
    const urlParams = new URLSearchParams(window.location.search);
    urlParams.set('q', value); // Set the 'q' parameter to the desired value
    // Update the browser's URL without reloading the page
    const newUrl = `${window.location.pathname}?${urlParams.toString()}`;
    window.history.replaceState(null, '', newUrl);
}
// function to set url query ends
// function to sync checked checkboxes when page is refreshed
function syncCheckboxesWithFilters(filters) {
  const flat = flattenUrlFilters(filters);
  // Skip car filter values (brands, models, years) - handled via backend API
  const filterValues = flat
    .filter(f => !f.startsWith('brands:') && !f.startsWith('models:') && !f.startsWith('years:'))
    .map((f) => f.split(':')[1])
    .filter(Boolean)
    .map(v => v.toLowerCase());

  document.querySelectorAll('.new-filter-input').forEach((checkbox) => {
    const checkboxValue = (checkbox.value || '').toLowerCase();
    checkbox.checked = filterValues.includes(checkboxValue);
  });
}

// function update pricehandle UI
// function updateActivePriceRange(){
//     const activeFiltersContainer = document.getElementById('active-filters');
//     const filterTag = document.createElement('span');
//     filterTag.className = 'active-filter';
//     filterTag.innerHTML = `<span class="active_label_name">${checkActiveName}:</span>  ${filterValue} <button class="remove-filter" data-filter="${checkName}" data-value='${filterValue}'><svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M7.41401 6.00001L11.707 1.70701C12.098 1.31601 12.098 0.684006 11.707 0.293006C11.316 -0.0979941 10.684 -0.0979941 10.293 0.293006L6.00001 4.58601L1.70701 0.293006C1.31601 -0.0979941 0.684006 -0.0979941 0.293006 0.293006C-0.0979941 0.684006 -0.0979941 1.31601 0.293006 1.70701L4.58601 6.00001L0.293006 10.293C-0.0979941 10.684 -0.0979941 11.316 0.293006 11.707C0.488006 11.902 0.744006 12 1.00001 12C1.25601 12 1.51201 11.902 1.70701 11.707L6.00001 7.41401L10.293 11.707C10.488 11.902 10.744 12 11 12C11.256 12 11.512 11.902 11.707 11.707C12.098 11.316 12.098 10.684 11.707 10.293L7.41401 6.00001Z" fill="#3D4246"></path></svg></button>`;
//     if(activeFiltersContainer){activeFiltersContainer.appendChild(filterTag);}

// }
// function update pricehandle UIends
// function to handle sorting 
function handleSortChange(selectedValue, reqBody, makeFilters, query) {

    // Hindre manual ved bilfilter
if (isCarFilterActive() && selectedValue === 'manual') {
  selectedValue = 'best-selling';
  try { setURLSortBy('best-selling'); } catch(e) {}
  if (sortBy) sortBy.value = 'best-selling';
}

  if (abortController) abortController.abort();
  abortController = new AbortController();

  const indexMap = {
    "best-selling": bestSeller,
    "price-ascending": priceAsc,
    "price-descending": priceDesc,
    "title-ascending": titleAsc,
    "title-descending": titleDesc,
    "created-ascending": createdAsc,
    "created-descending": createdDesc
  };

  /* Handle custom sorts — MÅ KOMME ETTER indexMap */
  if (selectedValue && selectedValue.startsWith('custom_')) {
    var customKey = selectedValue.replace('custom_', '');
    var customConfig = customSortsData.find(function(cs) { return cs.sort_key === customKey; });
    var fallbackKey = (customConfig && customConfig.fallback_sort) || 'best_seller';
    var fallbackMap = {
      'best_seller': 'best-selling', 'price_asc': 'price-ascending',
      'price_desc': 'price-descending', 'title_asc': 'title-ascending',
      'title_desc': 'title-descending', 'created_asc': 'created-ascending',
      'created_desc': 'created-descending'
    };
    var mappedFallback = fallbackMap[fallbackKey] || 'best-selling';
    var fallbackIndex = indexMap[mappedFallback] || bestSeller;
    replaceInnerHTMLWithProducts("#product-grid");
    if (makeFilters === true) replaceInnerHTMLWithFilters("#custom-strowmmen-filters");
    var csReqBody = Object.assign({}, reqBody, { hitsPerPage: 1000, page: 0 });
    csReqBody.filters = ensurePriceGuard(csReqBody.filters);
    setURLSortBy(selectedValue);
    var CS_PAGE_SIZE = (requestData && requestData.hitsPerPage) ? requestData.hitsPerPage : 40;
    fallbackIndex.search(query || '', csReqBody).then(function(data) {
      // Sort ALL hits by tag priority
      var sortedAll = data.hits;
      if (customConfig && customConfig.tags) {
        sortedAll = applyCustomTagSort(data.hits, customConfig.tags);
      }
      // Local pagination
      var currentPage = getPageFromUrl();
      var start = (currentPage - 1) * CS_PAGE_SIZE;
      var pageItems = sortedAll.slice(start, start + CS_PAGE_SIZE);
      totalFoundProducts = data.nbHits;
      createProductsUi(pageItems, data.nbHits, data.query);
      // Fake pagination object for createPagination
      var nbPages = Math.max(1, Math.ceil(sortedAll.length / CS_PAGE_SIZE));
      createPagination({ page: currentPage - 1, nbPages: nbPages }, reqBody);
      if (makeFilters === true) {
        createFilterUi(data.facets, data.facets_stats);
        defaultProductCount = data.nbHits;
      }
      mainContent.style.opacity = "1";
    }).catch(function(error) {
      if (error.name !== 'AbortError') console.error("Custom sort error:", error);
    });
    return;
  }

  // === MANUAL / UTVALGTE ===
  if (selectedValue === 'manual') {
    replaceInnerHTMLWithProducts("#product-grid");
    if (makeFilters === true) replaceInnerHTMLWithFilters("#custom-strowmmen-filters");

    // Sørg for at manual-lista er på plass
    collectDefaultOrderHandles();

    // Hent "mange nok" fra basisindeksen, så vi kan sortere korrekt og paginere lokalt
    const LOCAL_PAGE_SIZE = (requestData && requestData.hitsPerPage) ? requestData.hitsPerPage : 40;
    const baseReq = { ...reqBody, hitsPerPage: 1000, page: 0 }; // maks 1000 per Algolia-kall
    baseReq.filters = ensurePriceGuard(baseReq.filters);

    index.search('', baseReq).then((data) => {
      // Sorter alle treff vi fikk etter manual
      const sortedAll = sortHitsByManual(data.hits);

      // Lokalpaginering: finn nåværende URL-side (1-basert)
      const currentPage = getPageFromUrl();
      const start = (currentPage - 1) * LOCAL_PAGE_SIZE;
      const pageItems = sortedAll.slice(start, start + LOCAL_PAGE_SIZE);

      totalFoundProducts = data.nbHits;
      createProductsUi(pageItems, data.nbHits, data.query);

      // Lag "fake" pag-objekt så eksisterende createPagination kan brukes
      const nbPages = Math.max(1, Math.ceil(sortedAll.length / LOCAL_PAGE_SIZE));
      const fakeResponse = { page: currentPage - 1, nbPages };
      createPagination(fakeResponse, reqBody);

      if (hasBrandModelYear()) {
        let plate;
        if (localStorage.getItem("Selected-num-plate")) {
          plate = localStorage.getItem("Selected-num-plate");
          const url = new URL(window.location);
          url.searchParams.set("numPlate", plate);
          window.history.pushState({}, "", url);
          localStorage.removeItem("Selected-num-plate");
        } else {
          const params = new URLSearchParams(window.location.search);
          plate = params.get("numPlate") || "";
        }
        const BMY = [localStorage.getItem("Selected-brand"), localStorage.getItem("Selected-model"), localStorage.getItem("Selected-year")];
        createHeadings(plate, BMY);
      }

      if (makeFilters === true) {
        createFilterUi(data.facets, data.facets_stats);
        defaultProductCount = data.nbHits;
      }
      mainContent.style.opacity = "1";
    }).catch(error => {
      if (error.name !== 'AbortError') console.error("Error performing manual sort search:", error);
    });
    return;
  }

  // === STANDARD SORTERING via replica-indekser ===
  const selectedIndex = indexMap[selectedValue];
  if (selectedIndex) {
    replaceInnerHTMLWithProducts("#product-grid");
    if (makeFilters === true) replaceInnerHTMLWithFilters("#custom-strowmmen-filters");
    reqBody.filters = ensurePriceGuard(reqBody.filters);

    selectedIndex.search('', reqBody).then((data) => {
      totalFoundProducts = data.nbHits;
      createProductsUi(data.hits, data.nbHits, data.query);
      createPagination(data, reqBody);

      if (hasBrandModelYear()) {
        let plate;
        if (localStorage.getItem("Selected-num-plate")) {
          plate = localStorage.getItem("Selected-num-plate");
          const url = new URL(window.location);
          url.searchParams.set("numPlate", localStorage.getItem("Selected-num-plate"));
          window.history.pushState({}, "", url);
          localStorage.removeItem("Selected-num-plate");
        } else {
          const params = new URLSearchParams(window.location.search);
          plate = params.get("numPlate") || "";
        }
        let BMY = [localStorage.getItem("Selected-brand"), localStorage.getItem("Selected-model"), localStorage.getItem("Selected-year")];
        createHeadings(plate, BMY);
      }

      if (makeFilters === true) {
        createFilterUi(data.facets, data.facets_stats);
        defaultProductCount = data.nbHits;
      }
      mainContent.style.opacity = "1";
    }).catch(error => {
      if (error.name !== 'AbortError') console.error("Error performing search:", error);
    });
  } else {
    console.error("Invalid sort value:", selectedValue);
  }
}

function isCarFilterActive() {
  // Bruk eksisterende URL-sjekker først
  try {
    if (includingBMY() || hasBrandModelYear()) return true;
  } catch (e) {}
  // Evt. DOM-markører for bilfilter-sider (tilpass om du har en root)
  return !!document.querySelector('[data-bilfilter-active], .bilfilter-active, #BilfilterRoot');
}

function removeManualSortOption() {
  if (!sortBy) return;
  const opts = Array.from(sortBy.options || []);
  opts.forEach(o => { if (o.value === 'manual') o.remove(); });
}


function scrollToProducts(targetId, fixedElementSelectors = []) {
    // Get the target element
    const targetElement = targetId;
    if (!targetElement) {
        console.error(`Element with ID '${targetId}' not found.`);
        return;
    }
    // Calculate the total offset by summing the heights of all fixed elements
    const totalOffset = fixedElementSelectors.reduce((offset, selector) => {
        const element = document.querySelector(selector);
        return element ? offset + element.offsetHeight : offset;
    }, 0);
    // Calculate the final position
    const position = targetElement.getBoundingClientRect().top + window.scrollY - totalOffset;
    // Smoothly scroll to the calculated position
    window.scrollTo({
        top: position,
        behavior: 'smooth',
    });
}
// function to scroll to products grid ends
// func url ends here
// function to add skeelton
function addSkeletonToMainContent() {
    const allElements = productGrid ? productGrid.querySelectorAll("*") : null;
    allElements.forEach(element => element.classList.add("skeleton"));
}
// function to remove skeleton  
function removeSkeletonFromMainContent() {
    const allElements = productGrid ? productGrid.querySelectorAll("*") : null;
    allElements.forEach(element => element.classList.remove("skeleton"));
}
// function skeletons ends
// function to crate pagination
function createPagination(response, requestBody) {
    const { page, nbPages } = response; // Extract data from Algolia response
    const currentPage = page + 1;      // Convert to 1-based index
    const lastPage = nbPages;
    const nextPageUrl = currentPage < lastPage ? currentPage + 1 : null;
    const prevPageUrl = currentPage > 1 ? currentPage - 1 : null;

    const paginationContainer = document.querySelector('.pagination');

    // Clear existing pagination
    if (paginationContainer) {
        paginationContainer.innerHTML = '';
    }
    if (prevPageUrl) {
        paginationContainer.innerHTML += `
            <span class="custom-pagination page-number page-number-prev" data-page-number="${currentPage - 1}" aria-label="Previous page">
                prev
                <input class="new-pagnate" type="hidden" value="${currentPage - 1}" />
            </span>`;
    }
    if (lastPage > 1 && paginationContainer) {
        // Show first page
        paginationContainer.innerHTML += `
            <span class="page-number custom-pagination ${currentPage === 1 ? 'page-number-active' : ''}" data-page-number="1">1
                <input class="new-pagnate" type="hidden" value="1" />
            </span>`;

        // Show ellipsis if needed
        if (currentPage > 3) {
            paginationContainer.innerHTML += `<span class="page-number">…</span>`;
        }

        // Calculate the range of page numbers to show
        let start = Math.max(2, currentPage - 1);
        let end = Math.min(lastPage - 1, currentPage + 1);

        // Adjust range for start or end proximity
        if (currentPage <= 3) {
            start = 2;
            end = Math.min(4, lastPage - 1);
        } else if (currentPage >= lastPage - 2) {
            start = Math.max(2, lastPage - 3);
            end = lastPage - 1;
        }

        // Add page numbers
        for (let i = start; i <= end; i++) {
            paginationContainer.innerHTML += `
                <span class="page-number custom-pagination ${currentPage === i ? 'page-number-active' : ''}" data-page-number="${i}">${i}
                    <input class="new-pagnate" type="hidden" value="${i}" />
                </span>`;
        }

        // Show ellipsis if needed
        if (currentPage < lastPage - 2) {
            paginationContainer.innerHTML += `<span class="page-number">…</span>`;
        }

        // Show last page
        paginationContainer.innerHTML += `
            <span class="page-number custom-pagination ${currentPage === lastPage ? 'page-number-active' : ''}" data-page-number="${lastPage}">${lastPage}
                <input class="new-pagnate" type="hidden" value="${lastPage}" />
            </span>`;
        // Add next button if more pages exist
        if (nextPageUrl) {
            paginationContainer.innerHTML += `
                <span class="custom-pagination page-number page-number-next" data-page-number="${currentPage + 1}" aria-label="Next page">
                    <svg class="next-page" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                       <path d="M8.46967 19.4697C8.17678 19.7626 8.17678 20.2374 8.46967 20.5303C8.76256 20.8232 9.23744 20.8232 9.53033 20.5303L8.46967 19.4697ZM17 12L17.5303 12.5303C17.671 12.3897 17.75 12.1989 17.75 12C17.75 11.8011 17.671 11.6103 17.5303 11.4697L17 12ZM9.53033 3.46967C9.23744 3.17678 8.76256 3.17678 8.46967 3.46967C8.17678 3.76256 8.17678 4.23744 8.46967 4.53033L9.53033 3.46967ZM9.53033 20.5303L17.5303 12.5303L16.4697 11.4697L8.46967 19.4697L9.53033 20.5303ZM17.5303 11.4697L9.53033 3.46967L8.46967 4.53033L16.4697 12.5303L17.5303 11.4697Z" fill="#001A72"></path>
                    </svg>
                    <input class="new-pagnate" type="hidden" value="${currentPage + 1}" />
                </span>`;
        }
        paginationContainer.querySelectorAll('.custom-pagination').forEach(pageLink => {
            pageLink.addEventListener('click', function () {
                const newPageInput = pageLink.querySelector(".new-pagnate");
                const pageNumber = newPageInput ? newPageInput.value : pageLink.dataset.pageNumber;

                requestBody.page = pageNumber - 1; // Convert back to 0-based for Algolia
                // new changes
                handleSortChange(sortBy.value, requestData, false, requestData.query)
                // Scroll to the top of the products grid           
                // productGrid.scrollIntoView({
                //     behavior: 'smooth', // Smooth scrolling animation
                //     block: 'start', // Align to the top of the viewport
                // });
                scrollToProducts(productGrid, ['.announcement-bar-secondary-wrapper', '.announcement-bar-wrapper', '.head-mast', '.shopify-section']);
                // Update URL
                const url = new URL(window.location);
                url.searchParams.set('page', pageNumber);
                history.pushState(null, null, url.toString());
            });
        });
    }
}
function isSearchPage(){
    if(window.location.href.includes("search?q=")){
        return true
    }
    return false
}
// function pagination enddss
function fetchFacetFilters(requestData) {
  replaceInnerHTMLWithFilters("#custom-strowmmen-filters");

  const newReqData = {
    ...requestData,
    facetFilters: [`collection_ids:${collectionId}`],
    hitsPerPage: 0,
  };
  newReqData.filters = ensurePriceGuard(newReqData.filters);

  fetch(filterValApi, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Algolia-Application-Id': appId,
      'X-Algolia-API-Key': viewKey,
    },
    body: JSON.stringify(newReqData)
  })
  .then(res => { if (!res.ok) throw new Error('Failed to fetch Records'); return res.json(); })
  .then(data => {
    createFilterUi(data.facets, data.facets_stats);
    mainContent.style.opacity = "1";
    defaultProductCount = data.nbHits;
  })
  .catch(err => console.log(err));
}

// functions to create products and filters html
function generateProductHTML() {
    return `
        <li class="grid-item">
            <div class="card card-product card-product-no-rating color-background-2">
                <figure class="card-media card-media-contain" data-handle="4-connect-1-5mm2-hoyttalerkabel-100-ren-kobber">
                    <a href="/products/4-connect-1-5mm2-hoyttalerkabel-100-ren-kobber" data-bss-pl="active">
                        <div class="aspect-ratio skeleton" style="--ratio-percent: 100%;">   
                        </div>
                    </a>
                </figure>
                <div class="card-info-wrap">
                    <div class="card-info">
                        <h3 class="card-heading skeleton typography-body" data-handle="4-connect-1-5mm2-hoyttalerkabel-100-ren-kobber">
                            <a href="/products/4-connect-1-5mm2-hoyttalerkabel-100-ren-kobber" data-bss-pl="active">4 CONNECT 1,5mm2 høyttalerkabel, 100% ren kobber</a>
                        </h3>
                        <span class="metafields_introducts new-metafields_introducts skeleton">German Car Audio</span>
                        
                        <div class="badge-stock badge-stock-in skeleton" style="margin-left:10px;">
                            <span class="js-stock-text skeleton">Hovedlager: 7</span>
                        </div>
                    </div>
                    <div class="card-footer">
                        <div class="price ">
                            <div class="price-container">
                                <div class="price-regular">
                                    <span class="visually-hidden">Vanlig pris</span>
                                    <span class="price-item price-item-regular skeleton" >
                                        650.00 kr
                                        <span class="sup skeleton">inkl. mva</span>
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div class="card-floating-footer">
                            <product-form>
                                <form method="post" action="/cart/add" id="product-form-8317462708448" accept-charset="UTF-8" class="shopify-product-form" enctype="multipart/form-data" novalidate="novalidate" data-type="add-to-cart-form" data-stock-threshold="3" data-event-context=" - Collection: 1-DIN Spillere">
                                    <input type="hidden" name="form_type" value="product">
                                    <input type="hidden" name="utf8" value="✓">
                                    <input type="hidden" name="id" value="45544669020384">
                                    <div class="product-actions card-product-actions">
                                        <div class="product-actions-add-to-cart">
                                            <button type="submit" name=" add" class="skeleton button button-secondary button-add-to-cart button-solid">
                                                <span>Legg i handlekurv</span>
                                                <div class="button-overlay-spinner hidden">
                                                    <span class="spinner-xs"></span>
                                                </div>
                                            </button>
                                        </div>
                                    </div>
                                    <div class="product-form-error-message-wrapper form-status form-status-error" role="alert" hidden="">
                                        <span class="product-form-error-message"></span>
                                    </div>
                                    <input type="hidden" name="product-id" value="8317999907040">
                                    <input type="hidden" name="section-id" value="template--17924865786080__product-grid">
                                </form>
                            </product-form>
                        </div>
                    </div>
                </div>
            </div>
        </li>`;
}
function generateHeadingHTML() {
    return `
    <h2 class= "skeleton_heading">
    <p class="skeleton_heading_inner"></p>
    </h2>
    `
}
function generateFilterHTML() {
    return `
    <div class="js-filter">
        <div>
            <collapsible-expandable expanded="true">
                <div class="facet">
                    <button class="facet-toggle skeleton" type="button" aria-expanded="true">
                        <span>Category 1</span>
                        <span class="angle angle-down">
                            <span class="angle-icon"></span>
                        </span>
                    </button>
                    <div class="facet-content">
                        <ul class="facet-options-list" aria-expanded="false">
                            <li class="facet-options-list-item">
                                <span class="checkbox-facet skeleton">
                                    <label class="checkbox-facet-label skeleton">
                                        <input name="ttr_Category 1" value="10" active="Category 1" class="new-filter-input hidden" type="checkbox">
                                        <span class="checkbox-facet-check skeleton"></span>
                                        <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M17.5303 9.53033C17.8232 9.23744 17.8232 8.76256 17.5303 8.46967C17.2374 8.17678 16.7626 8.17678 16.4697 8.46967L17.5303 9.53033ZM9.99998 16L9.46965 16.5304C9.76255 16.8232 10.2374 16.8232 10.5303 16.5303L9.99998 16ZM7.53027 12.4697C7.23737 12.1768 6.7625 12.1768 6.46961 12.4697C6.17671 12.7626 6.17672 13.2374 6.46961 13.5303L7.53027 12.4697ZM16.4697 8.46967L9.46965 15.4697L10.5303 16.5303L17.5303 9.53033L16.4697 8.46967ZM6.46961 13.5303L9.46965 16.5304L10.5303 15.4697L7.53027 12.4697L6.46961 13.5303Z"></path>
                                        </svg>
                                        <span class="checkbox-facet-label-text">10"</span>
                                        <span class="checkbox-facet-label-count skeleton">58</span>
                                    </label>
                                </span>
                            </li> 
                            <li class="facet-options-list-item">
                                <span class="checkbox-facet skeleton">
                                    <label class="checkbox-facet-label skeleton" >
                                        <input name="ttr_Category 1" value="Audi" active="Category 1" class="new-filter-input hidden" type="checkbox">
                                        <span class="checkbox-facet-check skeleton"></span>
                                        <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M17.5303 9.53033C17.8232 9.23744 17.8232 8.76256 17.5303 8.46967C17.2374 8.17678 16.7626 8.17678 16.4697 8.46967L17.5303 9.53033ZM9.99998 16L9.46965 16.5304C9.76255 16.8232 10.2374 16.8232 10.5303 16.5303L9.99998 16ZM7.53027 12.4697C7.23737 12.1768 6.7625 12.1768 6.46961 12.4697C6.17671 12.7626 6.17672 13.2374 6.46961 13.5303L7.53027 12.4697ZM16.4697 8.46967L9.46965 15.4697L10.5303 16.5303L17.5303 9.53033L16.4697 8.46967ZM6.46961 13.5303L9.46965 16.5304L10.5303 15.4697L7.53027 12.4697L6.46961 13.5303Z"></path>
                                        </svg>
                                        <span class="checkbox-facet-label-text">Audi</span>
                                        <span class="checkbox-facet-label-count skeleton">1</span>
                                    </label>
                                </span>
                            </li> 
                            <li class="facet-options-list-item">
                                <span class="checkbox-facet skeleton">
                                    <label class="checkbox-facet-label skeleton">
                                        <input name="ttr_Category 1" value="Audi" active="Category 1" class="new-filter-input hidden" type="checkbox">
                                        <span class="checkbox-facet-check skeleton"></span>
                                        <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M17.5303 9.53033C17.8232 9.23744 17.8232 8.76256 17.5303 8.46967C17.2374 8.17678 16.7626 8.17678 16.4697 8.46967L17.5303 9.53033ZM9.99998 16L9.46965 16.5304C9.76255 16.8232 10.2374 16.8232 10.5303 16.5303L9.99998 16ZM7.53027 12.4697C7.23737 12.1768 6.7625 12.1768 6.46961 12.4697C6.17671 12.7626 6.17672 13.2374 6.46961 13.5303L7.53027 12.4697ZM16.4697 8.46967L9.46965 15.4697L10.5303 16.5303L17.5303 9.53033L16.4697 8.46967ZM6.46961 13.5303L9.46965 16.5304L10.5303 15.4697L7.53027 12.4697L6.46961 13.5303Z"></path>
                                        </svg>
                                        <span class="checkbox-facet-label-text">Audi</span>
                                        <span class="checkbox-facet-label-count skeleton">1</span>
                                    </label>
                                </span>
                            </li> 
                        </ul>
                        <div class="facet-content-footer">
                            <button class="button-text-link skeleton facet-button-more" type="button" form="FacetsFilterForm">+ Vis mer</button>
                        </div>
                    </div>
                </div>
            </collapsible-expandable>
        </div>
    </div>`;
}
function replaceInnerHTMLWithHeading(containerSelector) {
    let container = document.querySelector(containerSelector)
    if (!container) return;

    let headingHTML = '';
    for (let i = 0; i < 1; i++) {
        headingHTML += generateHeadingHTML();
    }

    container.innerHTML = headingHTML;
}
// function to replace inner html with products and filters 
function replaceInnerHTMLWithFilters(containerSelector) {
    const container = document.querySelector(containerSelector);
    if (!container) return;

    let filtersHTML = '';
    for (let i = 0; i < 2; i++) {
        filtersHTML += generateFilterHTML();
    }

    container.innerHTML = filtersHTML;
}
// endss

// function to replace inner html with products
function replaceInnerHTMLWithProducts(containerSelector) {
    const container = document.querySelector(containerSelector);
    if (!container) return;

    let productsHTML = '';
    for (let i = 0; i < 8; i++) {
        productsHTML += generateProductHTML();
    }

    container.innerHTML = productsHTML;
}
// functions replace endss
// removeFilterAndProducts
function removeFilterAndProducts(){
    let parentFilters = document.getElementById("custom-strowmmen-filters")
    let parentPaginate = document.querySelector(".pagination")
    let parentProducts = productGrid
    let activeFiltersWrap = document.getElementById("active-filters")
    let checkedBoxes = document.querySelectorAll(".new-filter-input")
    checkedBoxes.forEach(c=>{
        c.checked = false
    })

    updateActiveFiltersDisplay()
    // remove filter childs
    while (parentFilters.firstChild) {
        parentFilters.removeChild(parentFilters.firstChild);
    }
    while (activeFiltersWrap.firstChild) {
        activeFiltersWrap.removeChild(activeFiltersWrap.firstChild);
    }
    // remove products child
    while (parentProducts.firstChild) {
        parentProducts.removeChild(parentProducts.firstChild);
    }
    while (parentPaginate.firstChild) {
        parentPaginate.removeChild(parentPaginate.firstChild);
    }
    setURLFilters(""),
    setPriceFilters("")
    requestData.filters = ''
    console.log("filters affected from removefilterandproducts func line 1599")

    const clearAllButtonActive = document.querySelector('#active-filters-container #clear-all-filters');
    clearAllButtonActive.classList.add("hidden")
    productCount.textContent = ''
}
// removeFilterAndProducts ends

document.addEventListener("DOMContentLoaded",() => {
    // get filters and sort by from url if there they are
    let filters = getUrlFilters()
    let sortOrder = getURLSortBy()
    let currentPage = getPageFromUrl();
    let priceFilters = getPriceFilters()
    let searchedQuery = getUrlSearchQ()
    // let aiSearch = localStorage.getItem("ai_search")
    // hiding  ai search
    let aiSearch = false
    requestData.page = currentPage - 1
    
    // === MANUAL/UTVALGTE – SKRU HELT AV NÅR BILFILTER ER AKTIV ===
const carFilterOn = isCarFilterActive();

if (carFilterOn) {
  // 1) Fjern "manual" helt fra UI og URL
  removeManualSortOption();
  if (sortOrder === 'manual') {
    sortOrder = null; // reset so custom sort can take over
  }
  // 2) Default to first active custom sort (e.g. "anbefalt") when no sort in URL
  if (!sortOrder || sortOrder === 'null') {
    if (customSortsData && customSortsData.length > 0) {
      sortOrder = 'custom_' + customSortsData[0].sort_key;
      setURLSortBy(sortOrder);
    } else {
      sortOrder = 'best-selling';
      setURLSortBy(sortOrder);
    }
  }
  if (sortBy) sortBy.value = sortOrder;
  // Ikke kall noen manual-funksjoner her
} else {
  // Vanlig manual-støtte (kun når BMY IKKE er aktiv)
  collectDefaultOrderHandles();
  ensureManualSortOption();

  // Hvis ingen sort er satt i URL, og Shopify sier at collectionen er "manual",
  // så gjør "manual" til default (gjelder ikke på søkeside).
  if (!isSearchPage()) {
    const adminDefault = (getCollectionDefaultSort() || '').toLowerCase();
    const urlSort = getURLSortBy();
    if ((!urlSort || urlSort === 'null') && adminDefault === 'manual') {
      setURLSortBy('manual');
      sortOrder = 'manual';
      if (sortBy) sortBy.value = 'manual';
    }
  }

  // Hvis fortsatt ikke noe sort er satt, fall back til best-selling
  if ((sortOrder === null || typeof sortOrder === 'undefined') && sortBy) {
    setURLSortBy('best-selling');
    sortOrder = getURLSortBy();
  }

  if (sortBy) sortBy.value = sortOrder;
}

// === SLUTT PÅ MANUAL/UTVALGTE VAKT ===


    // if there's no sort order than we create sort order from the default value of sort dropdown
    if (sortOrder === null || !sortBy) {
        setURLSortBy("best-selling")
        // now re assign the sortvalue to sortOrder variable
        sortOrder = getURLSortBy()
    }
    if (searchedQuery) {
        requestData.query = searchedQuery
        searchInput.value = searchedQuery
        searchPageHeading.textContent = "Søkeresultater"
    }
    // if we have price filters? then set them to req data
    if (priceFilters.length > 0) {
        console.log("changes req data from onLoad")
        // converting these price filters to format that can be passed to algoliya
        const result = priceFilters.map(str => parseInt(str.split('=')[1], 10));
        if (typeof result[0] === "number" && typeof result[1] === "number" && !isNaN(result[0]) && !isNaN(result[1])) {
            console.log("result 1")
            requestData.filters = `price >= ${result[0]} AND price <= ${result[1]}`
            updateActiveFiltersDisplay()
        }
        else if (result[0] && !isNaN(result[0])) {
            console.log("result 1")
            requestData.filters = `price >= ${result[0]}`;
            updateActiveFiltersDisplay()
        }
        else if (result[1] && !isNaN(result[1])) {
            console.log("result 3")
            requestData.filters = `price <= ${result[1]}`;
            updateActiveFiltersDisplay()
        }
    }
    // update the value of sortBy dropdown 
    if(sortBy){
    sortBy.value = sortOrder
    }
    // === CAR FILTER: Intercept car filters and use backend API ===
    const carFilter = extractCarFiltersFromUrl();
    if (carFilter) {
      replaceInnerHTMLWithProducts("#product-grid");
      replaceInnerHTMLWithFilters("#custom-strowmmen-filters");
      
      fetchCarFilterIds(carFilter.brand, carFilter.model, carFilter.year).then(shopifyIds => {
        if (shopifyIds.length > 0) {
          const idFilter = buildIdFilter(shopifyIds);
          requestData.filters = ensurePriceGuard(idFilter);
          requestData.facetFilters = [`collection_ids:${collectionId}`];
          
          // Set heading
          localStorage.setItem("Selected-brand", carFilter.brand);
          localStorage.setItem("Selected-model", carFilter.model);
          localStorage.setItem("Selected-year", carFilter.year);
          
          handleSortChange(sortOrder, requestData, true, requestData.query);
          // Attach sort listener for car filter page
          sortBy?.addEventListener("change", (e) => {
            handleSortChange(sortBy.value, requestData, false, requestData.query);
            setURLSortBy(sortBy.value);
          });
        } else {
          requestData.facetFilters = [`collection_ids:${collectionId}`];
          handleSortChange(sortOrder, requestData, true, requestData.query);
        }
      });
      return; // Skip normal filter handling below
    }
    // === END CAR FILTER ===
    if (filters.length > 0) {
        // if filters length 1 and filter is the collection id that we have from product grid then just calling 1 api and having facets filters too with this
        if (filters.length === 1 && filters[0] === `collection_ids:${collectionId}`) {
            if(aiSearch === "true" && window.location.href.includes("search?q=") && searchedQuery !== ""){
                requestData.query
                deboundAiSearch(searchInput.value)
                searchPageHeading.textContent = "Søkeresultater"
            }
            else if(!window.location.href.includes("search?q=")){
                requestData.facetFilters = filters
                handleSortChange(sortOrder, requestData, true, requestData.query) 
            }
            else if (window.location.href.includes("search?q=") && aiSearch !== "true"){
                requestData.facetFilters = filters
                handleSortChange(sortOrder, requestData, true, requestData.query)
            }
        }
        //if thats not the case, then calling both api and getting facets and records seperately
        else {
            if(aiSearch === "true" && window.location.href.includes("search?q=")){
                deboundAiSearch(searchInput.value)
                searchPageHeading.textContent = "Søkeresultater"
            }
            else{
                requestData.facetFilters = filters
                // fetchFacetFilters(requestData)
                handleSortChange(sortOrder, requestData, true, requestData.query)
            }
        }
    }
    else {
        if(aiSearch === "true" && window.location.href.includes("search?q=") && searchedQuery !== ""){
            optimizeSearchQuery(searchInput.value)
            searchPageHeading.textContent = "Søkeresultater"
        }
        else if (window.location.href.includes("search?q=") && searchedQuery !== ""){
            handleSortChange(sortOrder, requestData, true, requestData.query)
        }
        else if (window.location.href.includes("search?q=") && searchedQuery == ""){
            searchPageHeading.textContent = "Please Type Something in Search Bar"
            removeFilterAndProducts()
        }
        else{
            handleSortChange(sortOrder, requestData, true, requestData.query)
        }
    }
    // add event listner change to the sort dropdown
    sortBy?.addEventListener("change", (e) => {
        let searchedQuery = getUrlSearchQ()
        if(isSearchPage() && searchedQuery == ""){
            return
        }
        handleSortChange(sortBy.value, requestData, false, requestData.query )
        setURLSortBy(sortBy.value)
    })
    searchInput?.addEventListener("input",(e) => {
        let aiBtn = document.querySelector("#ai-toggle")
        setUrlSearchQ(e.target.value)
        // if length of search characters is greater than 3 then search query
        if (e.target.value.length > 2) {
            requestData.query = e.target.value
            // Clear the previous timeout if there was one
            // clearTimeout(timeoutId);
            // timeoutId = setTimeout(() => {
                if(aiBtn.classList.contains("active")){
                    // empty  the query if ai search is active
                    requestData.query = ""
                    deboundAiSearch(e.target.value)
                    searchPageHeading.textContent = "Søkeresultater"
                    return
                }
                deboundHandleSort(sortBy.value, requestData, true)
                searchPageHeading.textContent = "Søkeresultater"
            // }, 500);
        }
        // else if search is cleared ? then getting all products
        else if (e.target.value.length === 0) {
            requestData.query = e.target.value
            // Clear the previous timeout if there was one
            // clearTimeout(timeoutId);
            // timeoutId = setTimeout(() => {
            //     requestData.hitsPerPage = 0
            //     requestData.maxValuesPerFacet = 1
            //     handleSortChange(sortBy.value, requestData, false)
            //     searchPageHeading.textContent = ""
            // }, 500);
            removeFilterAndProducts()
            searchPageHeading.textContent = "Please Type Something in Search Bar"
        }
    })
    searchInput?.classList.add("non-hover")
    // side bar open btn for mobile
    sidebarOpenButton?.addEventListener("click", (e) => {
        e.preventDefault()
        collectionPage.querySelector(".filters_side_bar_custom").classList.toggle("opened")
    })
    // searchInputGlobal?.addEventListener("input",(e)=>{
    //     // if length of search characters is greater than 3 then search query
    //     if (e.target.value.length > 2) {
    //         requestData.query = e.target.value
    //         // Clear the previous timeout if there was one
    //         // clearTimeout(timeoutId);
    //         // timeoutId = setTimeout(() => {
    //             deboundpredictiveSearch(e.target.value)
    //         // }, 500);
    //     }
    //     // else if search is cleared ? then getting all products
    //     else if (e.target.value.length === 0) {
    //         requestData.query = e.target.value
    //         // Clear the previous timeout if there was one
    //         // clearTimeout(timeoutId);
    //         // timeoutId = setTimeout(() => {
    //             deboundpredictiveSearch(e.target.value)
    //         // }, 500); 
    //     }
    // })
    // if ai search is enabled ? then active its class
    let aiBtn = document.querySelectorAll("#ai-toggle")
    // if(aiSearch === "true"){
    //     aiBtn.forEach(btns=>{
    //         btns.classList.add("active")
    //     })
    // }
})
function ensurePriceGuard(filters) {
  // ingen filter? -> bare prisvakt
  if (!filters || filters.trim() === "") return "price > 0";

  // hvis pris-intervallet eksplisitt sier >= 0, stram inn til >= 1
  let tightened = filters.replace(/price\s*>=\s*0\b/g, "price >= 1");

  // hvis det allerede finnes en "price > 0" eller et min >= 1, la det være
  if (/\bprice\s*>\s*0\b/.test(tightened) || /\bprice\s*>=\s*[1-9]/.test(tightened)) {
    return tightened;
  }

  // ellers legg til prisvakten
  return `${tightened} AND price > 0`;
}